import { forwardRef, memo, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ContainerBody from '../ContainerBody';
import ContainerHeader from '../ContainerHeader';
import PlaceOrder from '../../PlaceOrder/index';
import { BzButton, BzChip, BzDotsLoader, BzInputText, BzToggleButton } from '../../../../components';
import { Container, Row, Col } from "react-bootstrap";
import ContainerFooter from '../ContainerFooter';
import PlaceOrderTabs from '../../PlaceOrder/PlaceOrderTabs';
import { OrderMultiScrip, OrderSingleScrip, OrderSip } from '../../../../containers/PlaceOrderTypes';
import { handleModal, handleModalData } from '../../../../redux/actions/modals';
//PrachiTawde : 05-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - Start
import { getEqSipScripMaster, getExchangeWiseScripInfo, getMarketStatusFailure, getMultiLegData, getMultiScriptSecongLegSuccess, getOrderMarginInfo, getScripOrderInfo, getSpreadOrder, getSpreadOrderSuccess, getplaceMultilegOrderFailure, handleSpreadSideOrder, orderMarginInfoFailure, placeMultilegOrderAction, placeSingleScripBracketOrder, placeSingleScripCoverOrder, placeSingleScripOrder, placeSingleScripOrderFailure, placeSingleScripOrderSuccess, placeSipOrder, placeSipOrderFailure, setShowSideOrderConfirmation, setShowSideTrayOrderstatus, setShowSideTrayPlaceOrder, updateIsBuyOrSell, updateMultiLegOrderConfirmed, updateSingleScripOrderConfirmed, updateSpreadOrderInfo, getSipSettingDetails } from '../../../../redux/actions/orders';
import { WATCHLIST_GRID_INDEX, SIDE_TRAY_EXPAND_PERCENTAGE, ORDER_ENTRY_CONSTANTS, ORDER_TYPES, ORDER_PRODUCT_TYPES, ORDER_ENTRY_BUTTON_TOGGLE, MARKET_SEGMENT_ID, SCRIP_INSTRUMENTS, API_RESPONSE_STATUS, ALL_ORDERS_STATUS, ORDER_ENTRY_TYPES, NETWORK_RESPONSE_STATUS, FACILITY_NUM, ORDER_VALIDITY, LAYOUT_TYPE, SESSION_STORAGE_KEYS, GTD_DAYS_FOR_NCDEX, MSG_MASTER, SURV_MEASURE_POPUP_ACTION, MONTHLY_SIP_OPTIONS, FREQUENCY_TYPE } from '../../../../utils/global_variables';
import { WATCHLIST_GRID_REF, convertNumberWithCommasForCurrency, getApiExchangeNameFromMktSegId, getDecryptLocalStorage, getGSMGradeDescriptionFromScrip, getGroupedSegement, getMappedMktSegIdFromApiExchangeName, getOrderIdentifier, getProductTypeValue, getToFixedParseFloat, getValidityByExchangeName, isGuestUser, roundToNearest, validateLTPPriceBand } from '../../../../utils/global_functions';
import { toastConfig } from '../../../../redux/actions/toast';
import BrokerageCharges from '../../../PlaceOrderTypes/BrokerageCharges';
import SideOrderConfirmation from '../SidePlaceOrder/SideOrderConfirmation';
import OrderStatusBody from '../../../PlaceOrderTypes/OrderStatusBody';
import dayjs from 'dayjs';
import moment from 'moment';
import { _isEQSIPOrderAllowed, _isShowValidityOrderEntry } from '../../../../controllers/orders';
import ZeroStates from '../../../ZeroStates';
import { saveCartInfo, createOrderCartInfo, getOrderDataBackupVertical, getOrderCartAction, getOrderCartOrderSuccess, updateOrderCartAction } from '../../../../redux/actions/orderCart';
import { getMessagesOrders } from '../../../../redux/actions/messages';
import { useNavigate } from 'react-router';
import config from '../../../../config.json';
import { uniqBy } from 'lodash';
import LtpPriceBandValidationInfoModal from '../../../PlaceOrderTypes/OrderMultiScrip/LtpPriceBandValidationInfoModal';
//PrachiTawde : 05-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - End



const objSelectOrderOptionInit = {
    frequency: "MONTHLY",
    every: "First",
    day_date: "Day",
    day: "Monday",
    everyForWeekly: "MONDAY",
    productType: "",
    productTypeDesc: '',
    validityTypes: "DAY",
    orderType: ORDER_ENTRY_TYPES.RL,
    orderBy: 'Quantity',
    isAmo: false,
    isOCOChecked: false,// Azeem K:21-03-2025 BREEZE-131 Breeze - Introduction of GTT orders- OCO (One Cancels Other):BREEZE-4394 LLD Creation :added isOCOChecked field for control OCO checkbox
    selectSpecificFrequencyDate: 0,
    isDefaultProductType: true
};

let objOrderStatusScripData = {};
let nFundsRequiredPerLot = 0.00;
//Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
let isScripPrice = true;
//Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End

const SidePlaceOrder = forwardRef(({ setIsExpanded, setToggleSideContainer, setActiveMenu, setBIsSiderTrayOrderEntryOpen, ...props }, ref) => {
    const dispatch = useDispatch();
    const currentDate = new Date().toLocaleDateString("en-CA").split("/").reverse().join('-');
    const [selectOrderOption, setSelectOrderOption] = useState(objSelectOrderOptionInit);
    const [isBrokerageDisabled, setIsBrokerageDisabled] = useState(false);
    const [activeTabKey, setActiveTabKey] = useState(ORDER_TYPES.SINGLE_SCRIP);
    const [multiScripOrderActiveTabKey, setMultiScripOrderActiveTabKey] = useState(); //ManasaB : 08-10-2024 : Removed default value to stop rendering in side tray without clicking on Multiscrip
    const [legsThatFailLtpPriceValidation, setLegsThatFailLtpPriceValidation] = useState([]);
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    const ltpPriceBandMaster = useSelector(state => state.orders.ltpPriceBandMaster);
    const orderEntrySingleScripRef = useRef();
    const orderEntryMultiScripRef = useRef();
    const orderEntrySIPScripRef = useRef();
    const [bIsPlaceOrderBtnDisabled, setBIsPlaceOrderBtnDisabled] = useState(false);
    const [arrAllExchangeWiseProductTypes, setArrAllExchangeWiseProductTypes] = useState([]);
    const [toggleBracketOrder, setToggleBracketOrder] = useState({ isShow: false, strProductType: ORDER_PRODUCT_TYPES.COVER });
    const [orderInputs, setOrderInputs] = useState({
        scripQuantity: 1, scripLot: 1, scripAmount: 0, scripPrice: '', slTrigger: 0, quantity: 1, capPrice: 0, numberOfInstallment: 1, intradayTrigger: 0, intradayLimit: 0, intradayTrailing: 0, intradayProfit: 0, discQty: 0, protPercent: 0, startDate: currentDate, gtdDate: dayjs(currentDate, 'YYYY-MM-DD'),
        targetSelPrice: 0, targetSelTriggerPrice: 0  // Azeem K:21-03-2025 BREEZE-131 Breeze - Introduction of GTT orders- OCO (One Cancels Other):BREEZE-4394 LLD Creation :added two fields for Target Price and Target Trigger Price  inputs
    });
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

    //Bilal K : 26-07-2023 : BT-102676 - Breeze - SIP Order entry - Start
    const [isChecked, setIsChecked] = useState(false);
    const [selectSpecificFrequencyDate, setSelectSpecificFrequencyDate] = useState(1);
    const [bIsConfirmBtn, setBIsConfirmBtn] = useState(true);
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    const objSingleScripOrderResp = useSelector(state => state.orders.singleScripOrder);
    const arrScripExchanges = useSelector(state => state.orders.arrScripExchanges);
    const arrDistinctScripExchanges = useMemo(() => uniqBy(arrScripExchanges, WATCHLIST_GRID_INDEX.EXCHANGE), [arrScripExchanges]);
    const bIsShowSideTrayPlaceOrder = useSelector(state => state?.orders?.bIsShowSideTrayPlaceOrder);
    const bIsShowSideTrayOrderConfirmation = useSelector(state => state?.orders?.bIsShowSideTrayOrderConfirmation);
    const bIsShowSideTrayOrderStatus = useSelector(state => state?.orders?.bIsShowSideTrayOrderStatus);
    const objSipOrderResp = useSelector(state => state.orders.sipOrder);
    const arrMarginInfo = useSelector(state => state.orders.arrMarginInfo);
    const multiSpreadOrderInfo = useSelector(state => state?.orders?.multiSpreadOrderInfo);
    const isLoadingMarginInfo = useSelector(state => state.orders.isLoadingMarginInfo);
    const bIsSingleScripOrderConfirmed = useSelector(state => state.orders.isSingleScripOrderConfirmed);
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

    const sipSettingDetails = useSelector(state => state?.orders?.sipSettingDetails);
    //Bilal K : 26-07-2023 : BT-102676 - Breeze - SIP Order entry - End
    const objScripOrderInfo = useSelector(state => state.orders.scripOrderInfo);
    const objCFT = useSelector(state => state?.auth?.objCFT);
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start
    const arrOrderCartScripsInfo = useSelector(state => state?.orderCart?.arrOrderCartScrips);
    const arrOrderCartVertical = useSelector(state => state.orderCart.arrOrderDataBackupVertical);
    const [bIsShowCreateCart, setBIsShowCreateCart] = useState(false);
    const [orderCartName, setOrderCartName] = useState('');
    const [arrSaveCartResp, setArrSaveCartResp] = useState({});
    const objOrderCartOrderResp = useSelector(state => state.orderCart?.placeOrderCartOrderSuccess);
    const [bIsConfirmBack, setBIsConfirmBack] = useState(false);
    const [bIsSaveCartBack, setBIsSaveCartBack] = useState(false);
    const arrCartNames = useSelector(state => state?.orderCart?.arrOrderCart);
    const objModalData = useSelector(state => state?.modals?.modalData);
    const modals = useSelector(state => state?.modals?.modals);// AJitesh get modal data
    const orderCartMargin = useSelector(state => state?.orderCart?.orderCartMargin);
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End
    // Ajitesh 10-10-2024 Multileg data from redux
    const multiLegData = useSelector(state => state.orders.multiLegData);

    const setIsScripPrice = (bIsSetPrice) => {
        isScripPrice = bIsSetPrice;
    };
    // Vaibhav Singh: NSEEQ Order Entry: 31-01-24: Sidebar Not allowed for unavailable exchanges fixed: Start
    //PrachiTawde : 05-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - Start
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    const { scripOrderInfo, activeButtonToggleIndex, activeMktSegId } = useMemo(() => ({ scripOrderInfo: objScripOrderInfo?.scripData, activeButtonToggleIndex: objScripOrderInfo?.isBuySell, activeMktSegId: objScripOrderInfo?.activeExchangeId }), [objScripOrderInfo]);
    const [exchangeAllowed, setExchangeAllowed] = useState(true);
    //Maaz A : 10-10-2023 : BT-102298 - Breeze - Single Scrip Order entry : GTD Order - Start
    useEffect(() => {
        if (scripOrderInfo?.length) {
            const strExchangeName = getApiExchangeNameFromMktSegId(scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
            if (objLoginSession?.data?.exchanges?.includes(strExchangeName?.toUpperCase())) {
                setExchangeAllowed(true);
            } else {
                setExchangeAllowed(false);
            }
        }
    }, [objLoginSession?.data?.exchanges, scripOrderInfo]);
    const objEqSIPScripMaster = useSelector(state => state.orders.objEqSIPScripMaster);
    const bIsSipAllowed = useMemo(() => {
        let bIsAllowed = false;
        if (objEqSIPScripMaster && scripOrderInfo) {
            bIsAllowed = _isEQSIPOrderAllowed(scripOrderInfo[WATCHLIST_GRID_INDEX.SYMBOL], scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOrderInfo[WATCHLIST_GRID_INDEX.SERIES], objEqSIPScripMaster);

        }
        return bIsAllowed;
    }, [objEqSIPScripMaster, scripOrderInfo]);
    // Hari:K:05-01-2024: side-try-spread-order-start
    const handleSelectSpreadOrderModel = (spreadArr, strBuySell) => {
        dispatch(updateIsBuyOrSell(strBuySell));//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry
        var spreadPaylod =
        {
            "mktSegid": getMappedMktSegIdFromApiExchangeName(getApiExchangeNameFromMktSegId(spreadArr[WATCHLIST_GRID_INDEX.SEGMENT_ID])),//Ameersha N - 04-03-2024 - Sending Mapped Market Segment ID for spread API spreadArr[WATCHLIST_GRID_INDEX.SEGMENT_ID],
            "symbol": spreadArr[WATCHLIST_GRID_INDEX.SYMBOL],
            "token": spreadArr[WATCHLIST_GRID_INDEX.TOKEN]
        };
        dispatch(getSpreadOrder(spreadPaylod));
        const objScrpinfo = { activeExchangeId: '', isBuySell: 0, scripData: spreadArr };
        dispatch(getScripOrderInfo(objScrpinfo));
        dispatch(handleModalData({ data: { spreadArr: spreadArr } }), true);
    };
    useEffect(() => {
        dispatch(getOrderCartAction());
    }, []);
    useEffect(() => {
        if (scripOrderInfo?.length > 0) {
            dispatch(getExchangeWiseScripInfo(scripOrderInfo));
            if (objCFT?.MULTILEG || objCFT?.BULKORDER) {
                if (scripOrderInfo[WATCHLIST_GRID_INDEX.NSPREAD] === 1) {
                    handleSelectSpreadOrderModel(scripOrderInfo, 'BUY');
                    setActiveTabKey(ORDER_TYPES.MULTI_SCRIP);
                    if (objCFT?.MULTILEG) {
                        setMultiScripOrderActiveTabKey(ORDER_TYPES.SPREAD);
                    } else if (objCFT?.BULKORDER) {
                        setMultiScripOrderActiveTabKey(ORDER_TYPES.BASKET);
                    } else { }
                } else {
                    // Ajitesh : If multi leg tab already selected in sidetray persist the tab selection on scrip change in WL
                    if (objCFT?.MULTILEG && multiScripOrderActiveTabKey === ORDER_TYPES.MULTI_LEG) {
                        setMultiScripOrderActiveTabKey(ORDER_TYPES.MULTI_LEG);
                    }
                    else {
                        setActiveTabKey(ORDER_TYPES.SINGLE_SCRIP);  //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024
                    }
                }
            }
        } else { }
    }, [scripOrderInfo, objCFT?.BULKORDER, setActiveTabKey, objCFT?.MULTILEG, dispatch]);
    const bIsOrderEntryApiPending = useSelector(state => state.orders.bIsOrderEntryApiPending);//Azeem K : 26-03-2024 : BT-102298 - Breeze - Single Scrip Order entry -Loader added on order entry
    const brokerageParams = useMemo(() => {
        if (activeTabKey === ORDER_TYPES.SINGLE_SCRIP) {
            return {
                "producttype": selectOrderOption?.productType,
                "transactiontype": activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.BUY ? 1 : 2,
                "quantity": orderInputs?.scripQuantity,
                "price": orderInputs?.scripPrice || 0,
            };
        } else if (activeTabKey === ORDER_TYPES.MULTI_SCRIP) {
            return {
                "producttype": 'CARRYFORWARD',
                "transactiontype": 1,
                "quantity": 1,
                "price": 0,
            };
        } else {
            return {};
        }
    }, [activeTabKey, selectOrderOption?.productType, activeButtonToggleIndex, orderInputs?.scripQuantity, orderInputs?.scripPrice]);
    useEffect(() => {
        if (activeTabKey === ORDER_TYPES.EQUITY_SIP) {
            setBIsConfirmBtn(false);
        } else if (activeTabKey === ORDER_TYPES.SINGLE_SCRIP) {
            if (bIsOrderEntryApiPending) {
                setBIsConfirmBtn(false);
            } else if (objSingleScripOrderResp?.status === API_RESPONSE_STATUS.ERROR) {
                setBIsConfirmBtn(false);
            } else {
                setBIsConfirmBtn(true);
            }

        }
    }, [activeTabKey, objSingleScripOrderResp]);
    // Hari:K:05-01-2024: side-try-spread-order-start

    const defaultGtdDate = useMemo(() => {
        return dayjs(moment().add(scripOrderInfo?.length && scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES ? GTD_DAYS_FOR_NCDEX.DEFAULT_DATE : objLoginSession?.data?.others?.nGTDDefault, 'days').format('DD-MM-YYYY'), 'DD-MM-YYYY');
    }, [objLoginSession?.data?.others?.nGTDDefault, scripOrderInfo]);

    useEffect(() => {
        setOrderInputs(curr => ({ ...curr, gtdDate: defaultGtdDate }));
    }, [defaultGtdDate]);
    //Maaz A : 10-10-2023 : BT-102298 - Breeze - Single Scrip Order entry : GTD Order - End

    //Maaz A : 17-11-2023 : Client Facility Template - Added for MultiLeg and Spread - Start
    //ManasaB : 08-10-2024 : Removed default value to stop rendering in side tray without clicking on Multiscrip - Start
    // useEffect(() => {
    //     if (objCFT?.BULKORDER) {
    //         console.log('before changing ')
    //         setMultiScripOrderActiveTabKey(ORDER_TYPES.BASKET);
    //     } else if (objCFT?.MULTILEG) {
    //         setMultiScripOrderActiveTabKey(ORDER_TYPES.MULTI_LEG);
    //     } else { }
    // }, [objCFT]);
    //ManasaB : 08-10-2024 : Removed default value to stop rendering in side tray without clicking on Multiscrip - End
    //Maaz A : 17-11-2023 : Client Facility Template - Added for MultiLeg and Spread - End

    //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - Start
    const orderQuantityCaption = useMemo(() => {
        if (scripOrderInfo?.length > 0) {
            let arrTypeCaption = [];
            let objUserOrderPreference = getDecryptLocalStorage('PREFERRED_ORDER_SELECTION');
            if (objUserOrderPreference && objUserOrderPreference?.length > 0) {
                objUserOrderPreference = JSON.parse(objUserOrderPreference);
            } else {
                objUserOrderPreference = {};
            }
            const strScripSegment = getGroupedSegement(scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE], scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT]);

            if (scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES) {
                arrTypeCaption = [{ type: 'Quantity', isDefault: false }, { type: 'Amount', isDefault: false }];
            } else {
                arrTypeCaption = [{ type: 'Lot', isDefault: false }, { type: 'Quantity', isDefault: false }, { type: 'Amount', isDefault: false }];
            }
            if (objUserOrderPreference[strScripSegment]?.type) {
                const nIndex = arrTypeCaption?.findIndex(obj => obj.type === objUserOrderPreference[strScripSegment]?.type);
                if (nIndex >= 0) {
                    arrTypeCaption[nIndex] = objUserOrderPreference[strScripSegment];
                } else { }
            } else { }
            return [...arrTypeCaption];
        } else {
            return [{ type: 'Quantity', isDefault: false }, { type: 'Amount', isDefault: false }];
        }
    }, [scripOrderInfo]);

    //Maaz A : 27-09-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

    useEffect(() => {
        if (WATCHLIST_GRID_REF?.current?.api?.getSelectedRows() && WATCHLIST_GRID_REF?.current?.api?.getSelectedRows().length > 0) {
            const arrSelectedRowScripData = WATCHLIST_GRID_REF?.current?.api?.getSelectedRows()[0];
            dispatch(getScripOrderInfo({ isBuySell: activeButtonToggleIndex, activeExchangeId: arrSelectedRowScripData[WATCHLIST_GRID_INDEX.EXCHANGE], scripData: arrSelectedRowScripData }));
            dispatch(getExchangeWiseScripInfo(arrSelectedRowScripData));
        } else { }
        if (Object.keys(objEqSIPScripMaster)?.length === 0 && !isGuestUser()) {
            dispatch(getEqSipScripMaster());
        } else { }
    }, [dispatch]);

    useEffect(() => {
        if (activeTabKey === ORDER_TYPES.MULTI_SCRIP && multiScripOrderActiveTabKey === ORDER_TYPES.SPREAD) {
            if (multiSpreadOrderInfo?.placeOrder) {
                if (multiSpreadOrderInfo?.quantity === 0 || multiSpreadOrderInfo?.quantity === "0") {
                    setBIsPlaceOrderBtnDisabled(true);
                } else {
                    setBIsPlaceOrderBtnDisabled(false);
                }
            } else {
                setBIsPlaceOrderBtnDisabled(true);
            }
        } else if (activeTabKey == ORDER_TYPES.MULTI_SCRIP && multiScripOrderActiveTabKey === ORDER_TYPES.MULTI_LEG) { // Ajitesh Condition to handle multileg tab inside sidetray
            // Condition to disable Place order btn when user opens multileg for EQ scrips or when legs are loading or < 2
            if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES || multiLegData.length < 2) {
                setBIsPlaceOrderBtnDisabled(true);
            }
            else {
                setBIsPlaceOrderBtnDisabled(false);
            }
        } else if (activeTabKey === ORDER_TYPES.SINGLE_SCRIP) {
            if (scripOrderInfo?.length) {
                //Maaz A : 15-12-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Fixes- Start
                if (selectOrderOption?.orderBy === 'Quantity') {
                    if (isNaN(parseFloat(orderInputs?.scripPrice)) || !selectOrderOption?.productType || (parseFloat(orderInputs?.scripPrice) === 0 && (selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.RL_MKT && selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.SL_MKT)) || isNaN(parseInt(orderInputs?.scripQuantity)) || parseInt(orderInputs?.scripQuantity) === 0 || ((selectOrderOption?.orderType?.includes(ORDER_ENTRY_TYPES?.SL) || selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT) && (isNaN(parseFloat(orderInputs?.slTrigger)) || parseFloat(orderInputs?.slTrigger) === 0)) || (selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT && selectOrderOption?.isOCOChecked && (isNaN(parseFloat(orderInputs?.targetSelPrice)) || parseFloat(orderInputs?.targetSelPrice) === 0 || isNaN(parseFloat(orderInputs?.targetSelTriggerPrice)) || parseFloat(orderInputs?.targetSelTriggerPrice) === 0))) {// BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 - added condition for trigger price in case of GTT
                        setBIsPlaceOrderBtnDisabled(true);
                    } else {
                        setBIsPlaceOrderBtnDisabled(false);
                    }
                } else if (selectOrderOption?.orderBy === 'Amount') {
                    if (isNaN(parseFloat(orderInputs?.scripPrice)) || !selectOrderOption?.productType || isNaN(parseInt(orderInputs?.scripQuantity)) || parseInt(orderInputs?.scripQuantity) === 0 || (parseFloat(orderInputs?.scripPrice) == 0 && (selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.RL_MKT && selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.SL_MKT)) || isNaN(parseFloat(orderInputs?.scripAmount)) || parseFloat(orderInputs?.scripAmount) === 0 || ((selectOrderOption?.orderType?.includes(ORDER_ENTRY_TYPES?.SL) || selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT) && (isNaN(parseFloat(orderInputs?.slTrigger)) || parseFloat(orderInputs?.slTrigger) == 0)) || (selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT && selectOrderOption?.isOCOChecked && (isNaN(parseFloat(orderInputs?.targetSelPrice)) || parseFloat(orderInputs?.targetSelPrice) === 0 || isNaN(parseFloat(orderInputs?.targetSelTriggerPrice)) || parseFloat(orderInputs?.targetSelTriggerPrice) === 0))) {// BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 - added condition for trigger price in case of GTT
                        setBIsPlaceOrderBtnDisabled(true);
                    } else {
                        setBIsPlaceOrderBtnDisabled(false);
                    }
                } else if (selectOrderOption?.orderBy === 'Lot') {
                    if (isNaN(parseFloat(orderInputs?.scripPrice)) || !selectOrderOption?.productType || (parseFloat(orderInputs?.scripPrice) == 0 && (selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.RL_MKT && selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.SL_MKT)) || isNaN(parseInt(orderInputs?.scripLot)) || parseInt(orderInputs?.scripLot) == 0 || ((selectOrderOption?.orderType?.includes(ORDER_ENTRY_TYPES?.SL) || selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT) && (isNaN(parseFloat(orderInputs?.slTrigger)) || parseFloat(orderInputs?.slTrigger) == 0)) || (selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT && selectOrderOption?.isOCOChecked && (isNaN(parseFloat(orderInputs?.targetSelPrice)) || parseFloat(orderInputs?.targetSelPrice) === 0 || isNaN(parseFloat(orderInputs?.targetSelTriggerPrice)) || parseFloat(orderInputs?.targetSelTriggerPrice) === 0))) {// BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 - added condition for trigger price in case of GTT
                        setBIsPlaceOrderBtnDisabled(true);
                    } else {
                        setBIsPlaceOrderBtnDisabled(false);
                    }
                }
                else { }
                //Maaz A : 15-12-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Fixes- End
            } else {
                setBIsPlaceOrderBtnDisabled(true);
            }
        } else if (activeTabKey === ORDER_TYPES.EQUITY_SIP) {
            if (isNaN(orderInputs.quantity) || orderInputs?.quantity < 1 || isNaN(orderInputs?.numberOfInstallment) || (orderInputs?.numberOfInstallment) > (sipSettingDetails?.frequency_details?.[selectOrderOption?.frequency]?.installment_max) || (orderInputs?.numberOfInstallment < sipSettingDetails?.frequency_details?.[selectOrderOption?.frequency]?.installment_min)) {
                setBIsPlaceOrderBtnDisabled(true);
            } else {
                setBIsPlaceOrderBtnDisabled(false);
            }
        }
        //BREEZE-305 : ManasaB : 16-10-2024 : Watchlist Side tray- Order Cart Order entry - Start
        else if (activeTabKey == ORDER_TYPES.MULTI_SCRIP && multiScripOrderActiveTabKey == ORDER_TYPES.BASKET) {
            //  setBIsPlaceOrderBtnDisabled(false);
        }
        // Ajitesh Condition to handle multileg tab inside sidetray
        else if (activeTabKey == ORDER_TYPES.MULTI_SCRIP && multiScripOrderActiveTabKey === ORDER_TYPES.MULTI_LEG) {
            // Condition to disable Place order btn when user opens multileg for EQ scrips
            if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES) {
                setBIsPlaceOrderBtnDisabled(true);
            }
            else {
                setBIsPlaceOrderBtnDisabled(false);
            }
        }
        //BREEZE-305 : ManasaB : 16-10-2024 : Watchlist Side tray- Order Cart Order entry - End
    }, [orderInputs?.scripPrice, orderInputs?.scripQuantity, orderInputs?.scripAmount, orderInputs?.scripLot, orderInputs?.slTrigger, selectOrderOption?.orderBy, activeTabKey, selectOrderOption?.productType, selectOrderOption?.orderType, sipSettingDetails?.frequency_details, orderInputs?.numberOfInstallment, orderInputs.quantity, selectOrderOption?.frequency, multiScripOrderActiveTabKey, multiSpreadOrderInfo?.quantity, scripOrderInfo, bIsSipAllowed, selectOrderOption?.validityTypes, multiLegData, selectOrderOption?.isOCOChecked, orderInputs?.targetSelPrice, orderInputs?.targetSelTriggerPrice]);


    useEffect(() => {

    }, [activeTabKey, orderInputs, selectOrderOption, sipSettingDetails]);

    useEffect(() => {
        setToggleBracketOrder(curr => ({ ...curr, isShow: false }));
        if (selectOrderOption?.orderBy === 'Amount') {
            setOrderInputs(curr => ({ ...curr, quantity: 0, scripQuantity: 0, scripLot: 0, scripAmount: 1 }));
        } else if (selectOrderOption?.orderBy === 'Lot') {
            setOrderInputs(curr => ({ ...curr, quantity: 0, scripQuantity: 0, scripLot: 1, scripAmount: 0 }));
        } else {
            setOrderInputs(curr => ({ ...curr, quantity: 1, scripQuantity: 1, scripLot: 0, scripAmount: 0 }));
        }
        // setOrderInputs({ scripQuantity: 1, scripLot: 1, scripAmount: 0, scripPrice: '', slTrigger: 0, quantity: 0, capPrice: 0, numberOfInstallment: 0, intradayTrigger: 0, intradayLimit: 0, intradayTrailing: 0, intradayProfit: 0, discQty: 0, gtdDate: defaultGtdDate });
        setSelectOrderOption(objSelectOrderOptionInit);
    }, []);

    useEffect(() => {
        if (scripOrderInfo?.length > 0) {
            setOrderInputs(curr => ({ ...curr, scripPrice: 0 }));
            const nAskPrice = parseFloat(scripOrderInfo[WATCHLIST_GRID_INDEX.ASK_PRICE]);
            const nLTP = parseFloat(scripOrderInfo[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]);
            const nBidPrice = parseFloat(scripOrderInfo[WATCHLIST_GRID_INDEX.BID_PRICE]);
            if (activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
                if (nAskPrice > 0) {
                    setOrderInputs(curr => ({ ...curr, scripPrice: nAskPrice }));
                } else {
                    setOrderInputs(curr => ({ ...curr, scripPrice: nLTP }));
                }
            } else {
                if (nBidPrice > 0) {
                    setOrderInputs(curr => ({ ...curr, scripPrice: nBidPrice }));
                } else {
                    setOrderInputs(curr => ({ ...curr, scripPrice: nLTP }));
                }
            }
        } else { }
    }, [scripOrderInfo, activeButtonToggleIndex]);

    //Azeem K : 12-07-2024 : BT-102298 - Breeze - Single Scrip SideTray Order entry  - Start
    const userPreference = useSelector(state => state.notification.userPreference);

    const objActiveExchangeUserPreference = useMemo(() => {
        if (userPreference?.length > 0 && userPreference[userPreference.length - 1]?.sExchange && scripOrderInfo?.length > 0) {
            const arrUserPreferenceProductType = JSON.parse(userPreference[userPreference.length - 1]?.sExchange);
            const objActiveExchangeUserPreference = arrUserPreferenceProductType?.find(obj => obj?.marketSegmentId == scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
            if (objActiveExchangeUserPreference && Object.keys(objActiveExchangeUserPreference).length > 0) {
                return objActiveExchangeUserPreference;
            } else {
                return {};
            }
        } else {
            return {};
        }
    }, [scripOrderInfo, userPreference]);
    useEffect(() => {
        if (arrAllExchangeWiseProductTypes.length > 0) {
            const initProdType = selectOrderOption?.productType || objSelectOrderOptionInit.productType;
            const objSelProductType = arrAllExchangeWiseProductTypes?.find(obj => obj.sDefaultProductType == initProdType);

            let nIndexOfDefaultProductType = arrAllExchangeWiseProductTypes?.findIndex((eachItem) => (eachItem?.sDefaultProductType === objActiveExchangeUserPreference?.productType));
            if (objSelProductType?.sDescription) {
                setSelectOrderOption(curr => ({ ...curr, productTypeDesc: objSelProductType?.sDescription.toUpperCase() }));
            } else { }

        } else { }

    }, [arrAllExchangeWiseProductTypes, selectOrderOption?.productType, objActiveExchangeUserPreference]);
    //Azeem K : 12-07-2024 : BT-102298 - Breeze - Single Scrip SideTray Order entry  - End
    let frequency
    let Weekly
    let days
    if (sipSettingDetails?.frequency_details) {
        frequency = Object.keys(sipSettingDetails?.frequency_details);
        Weekly = sipSettingDetails?.frequency_details?.WEEKLY?.specific_week_days;
        days = sipSettingDetails?.frequency_details[selectOrderOption?.frequency]?.specific_dates;

    } else {
        frequency = [];
        Weekly = [];
        days = [];
    }

    useEffect(() => {
        if (Object.keys(sipSettingDetails).length <= 0) {
            if (!isGuestUser()) {
                dispatch(getSipSettingDetails());
            } else { }
        }
    }, [sipSettingDetails, dispatch]);

    useEffect(() => {
        setSelectSpecificFrequencyDate(selectOrderOption?.frequency === FREQUENCY_TYPE.MONTHLY ? 1 : 15);
        if (selectOrderOption?.frequency === FREQUENCY_TYPE.MONTHLY) {
            setSelectOrderOption(curr => ({ ...curr, selectSpecificFrequencyDate:(days?.length === 1 && days[0] === "")|| days?.length === 0 ? new Date().getDate() : days[0] }));
        } else if (selectOrderOption?.frequency === FREQUENCY_TYPE.FORTHNIGHTLY) {
            setSelectOrderOption(curr => ({ ...curr, selectSpecificFrequencyDate: days?.length > 0 && days[0] ? days[0] : 15 }));
        } else if (selectOrderOption?.frequency === FREQUENCY_TYPE.WEEKLY) {
            setSelectOrderOption(curr => ({ ...curr, everyForWeekly: Weekly?.length > 0 && Weekly[0] ? Weekly[0] : "MONDAY" }));
        }
    }, [selectOrderOption?.frequency]);

    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const calculateQuantityAsPerAmount = (selAmount) => {
        const amt = parseFloat(selAmount);
        const price = parseFloat(orderInputs?.scripPrice);
        if (amt > 0 && price !== 0 && scripOrderInfo?.length > 0) {
            let qty = '';
            if (!isNaN(nFundsRequiredPerLot) && nFundsRequiredPerLot !== 0) {
                qty = Math.floor(amt / nFundsRequiredPerLot);
            }
            if ((scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_CASH || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSE_CASH) && scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT].toUpperCase() === SCRIP_INSTRUMENTS.EQUITIES && scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT] > 1 && qty > 0) {
                qty = qty * scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT];
            }
            if (scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] !== MARKET_SEGMENT_ID.NSE_CASH && scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] !== MARKET_SEGMENT_ID.BSE_CASH) {
                if ((scripOrderInfo[WATCHLIST_GRID_INDEX.OPTIONTYPE] === "CE" || scripOrderInfo[WATCHLIST_GRID_INDEX.OPTIONTYPE] === "PE") && activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
                    qty = Math.floor(amt / (price * scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT]));
                }
            }

            if ((selectOrderOption?.productType === ORDER_PRODUCT_TYPES.DELIVERY || selectOrderOption?.productType === ORDER_PRODUCT_TYPES.MTF || selectOrderOption?.productType === ORDER_PRODUCT_TYPES.PTST) && activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.SELL) {
                qty = Math.floor(amt / price);
            }

            if (!(isNaN(parseInt(qty))))
                var selQty = Math.abs(qty);

            else
                selQty = 0;

        } else {
            selQty = 0;
        }
        return selQty;
    };

    const handleOrderInputs = useCallback((event) => {
        const { name, value } = event.target;

        if (name === "capPrice") {
            setOrderInputs(curr => ({ ...curr, [name]: isNaN(value) ? 0 : value.slice(0, ORDER_ENTRY_CONSTANTS.CAP_PRICE_LENGTH) }));
        }
        //Maaz A : 24-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - Start
        else if (name === "scripLot") {
            const strLot = isNaN(value) ? 0 : value?.toString().slice(0, ORDER_ENTRY_CONSTANTS.QUANTITY_LENGTH);
            const nLot = parseInt(isNaN(parseInt(strLot)) ? 0 : strLot);
            const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
            setOrderInputs(curr => ({ ...curr, [name]: strLot, scripQuantity: parseInt(nLot * nScripReularLot) }));
        }
        else if (name === "scripAmount") {
            const strAmount = isNaN(value) ? 0 : value?.toString().slice(0, ORDER_ENTRY_CONSTANTS.AMOUNT_LENGTH);
            const nAmount = isNaN(parseFloat(strAmount)) ? 0 : parseFloat(strAmount);
            const nLot = calculateQuantityAsPerAmount(nAmount);
            const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
            setOrderInputs(curr => ({ ...curr, [name]: strAmount, scripQuantity: parseInt(nLot * nScripReularLot), scripLot: nLot }));
        }
        //Maaz A : 27-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE CDS Bug Fixes - Start
        else if (name === "scripQuantity") {
            const strScripQuantity = isNaN(value) ? 0 : value?.toString().slice(0, ORDER_ENTRY_CONSTANTS.QUANTITY_LENGTH);
            let nScripQuantity = parseInt(isNaN(parseInt(strScripQuantity)) ? 0 : strScripQuantity);
            const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
            let nUpdatedLot = parseInt(Math.round(nScripQuantity / nScripReularLot));
            setOrderInputs(curr => ({ ...curr, [name]: strScripQuantity, scripLot: nUpdatedLot }));
        }
        //Maaz A : 27-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE CDS Bug Fixes - End
        else if (name === "intradayTrailing") {
            setOrderInputs(curr => ({ ...curr, [name]: isNaN(value) ? 0 : value.slice(0, ORDER_ENTRY_CONSTANTS.QUANTITY_LENGTH) }));
        }
        //Maaz A : 24-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - End
        else if (name === "quantity") {
            setOrderInputs(curr => ({ ...curr, [name]: isNaN(value) ? 0 : value.slice(0, ORDER_ENTRY_CONSTANTS.QUANTITY_LENGTH) }));
        }
        else if (name === "numberOfInstallment") {
            setOrderInputs(curr => ({ ...curr, [name]: isNaN(value) ? 0 : value.slice(0, ORDER_ENTRY_CONSTANTS.NUMBER_OF_INSTALLMENT_LENGTH) }));
        }
        else if (name === "startDate") {
            setOrderInputs(curr => ({ ...curr, [name]: value }));
        }
        //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
        else if (name === "discQty") {
            setOrderInputs(curr => ({ ...curr, [name]: isNaN(value) ? 0 : value.slice(0, ORDER_ENTRY_CONSTANTS.QUANTITY_LENGTH) }));
        }
        else if (name === "protPercent") {
            setOrderInputs(curr => ({ ...curr, [name]: isNaN(value) ? 0 : value.slice(0, ORDER_ENTRY_CONSTANTS.PROTECTION_PERCENTAGE_LENGTH) }));
        }
        //Maaz A : 23-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - GTD Bug Fixes - Start
        else if (name === "gtdDate") {
            setOrderInputs(curr => ({ ...curr, [name]: isNaN(value) ? 0 : value }));
        }
        //Maaz A : 23-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - GTD Bug Fixes - End
        else {
            setOrderInputs(curr => ({ ...curr, [name]: isNaN(value) ? 0 : value.slice(0, ORDER_ENTRY_CONSTANTS.PRICE_LENGTH) }));
        }
        //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
    }, [calculateQuantityAsPerAmount, scripOrderInfo]);


    const handleOnSelectOrderOptionChange = useCallback((e) => {
        const { name, value } = e.target;
        // Maaz A: Commented toggle bracket to false because if open from external source and toggle bracket, it again make toggle false
        // setToggleBracketOrder(curr => ({ ...curr, isShow: false }));
        if (name === 'orderBy') {
            setSelectOrderOption(curr => ({ ...curr, [name]: value }));
        } else if (name === 'productType') {
            setSelectOrderOption(curr => ({ ...curr, [name]: value }));
            if (arrAllExchangeWiseProductTypes.length > 0) {
                const objSelProductType = arrAllExchangeWiseProductTypes?.find(obj => obj.sDefaultProductType === value);
                if (objSelProductType?.sDescription) {
                    setSelectOrderOption(curr => ({ ...curr, productTypeDesc: objSelProductType?.sDescription.toUpperCase() }));
                } else { }
            } else { }
        } else if (name === 'isAmo') {
            setSelectOrderOption(curr => ({ ...curr, [name]: value }));
        }
        else if (name === 'orderType') {
            if (value === ORDER_ENTRY_TYPES.RL || value === ORDER_ENTRY_TYPES.RL_MKT || (selectOrderOption?.orderType === ORDER_ENTRY_TYPES.RL && value?.includes(ORDER_ENTRY_TYPES.SL))) {
                handleOrderInputs({ target: { name: 'slTrigger', value: '0.00' } });
            } else if (value === ORDER_ENTRY_TYPES.SL || value === ORDER_ENTRY_TYPES.SL_MKT) {
                setToggleBracketOrder(curr => ({ ...curr, isShow: false }));
            }
            setSelectOrderOption(curr => ({ ...curr, [name]: value }));
        }
        else if (name === "frequency") {
            if (value === FREQUENCY_TYPE.FORTHNIGHTLY) {
                setSelectOrderOption(curr => ({ ...curr, everyForWeekly: "", [name]: value }));
            } else {
                setSelectOrderOption(curr => ({ ...curr, [name]: value }));
            }
        }
        else {
            setSelectOrderOption(curr => ({ ...curr, [name]: value }));
        }
    }, [arrAllExchangeWiseProductTypes, selectOrderOption?.orderType]);

    const handleOrderStepsOnChange = useCallback((name, upDown) => {
        if (upDown === 'increase') {
            if (name === "capPrice") {
                setOrderInputs(curr => ({ ...curr, [name]: Math.min(isNaN(parseFloat(curr[name])) ? 0 : parseFloat(curr[name]) + 1, ORDER_ENTRY_CONSTANTS.CAP_PRICE_MAX_RANGE) }));
            }
            else if (name === "scripLot") {
                let nLot = parseInt(isNaN(orderInputs?.scripLot) ? 0 : orderInputs?.scripLot);
                nLot = Math.min((nLot + 1), ORDER_ENTRY_CONSTANTS.QUANTITY_MAX_RANGE);
                const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
                setOrderInputs(curr => ({ ...curr, [name]: nLot, scripQuantity: parseInt(nLot * nScripReularLot) }));
            }
            //Maaz A : 24-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - Start
            else if (name === "scripAmount") {
                let nAmount = isNaN(parseFloat(orderInputs.scripAmount)) ? 0 : parseFloat(orderInputs.scripAmount);
                nAmount = Math.min(nAmount + 1, ORDER_ENTRY_CONSTANTS.AMOUNT_MAX_RANGE);
                const nLot = calculateQuantityAsPerAmount(nAmount);
                const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
                setOrderInputs(curr => ({ ...curr, [name]: nAmount, scripQuantity: parseInt(nLot * nScripReularLot), scripLot: nLot }));
            }
            else if (name === "scripQuantity") {
                let nScripQuantity = parseInt(isNaN(orderInputs?.scripQuantity) ? 0 : orderInputs?.scripQuantity);
                const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
                if (nScripQuantity % nScripReularLot === 0) {
                    var nUpdatedScripQuantity = Math.min(parseInt(nScripQuantity + nScripReularLot), ORDER_ENTRY_CONSTANTS.QUANTITY_MAX_RANGE);
                } else {
                    nUpdatedScripQuantity = Math.min(parseInt(Math.ceil(nScripQuantity / nScripReularLot) * nScripReularLot), ORDER_ENTRY_CONSTANTS.QUANTITY_MAX_RANGE);
                }
                let nUpdatedLot = parseInt(Math.round(nUpdatedScripQuantity / nScripReularLot));
                setOrderInputs(curr => ({ ...curr, scripLot: nUpdatedLot, [name]: nUpdatedScripQuantity }));
            }
            //Maaz A : 24-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - End
            else if (name === "quantity" || name === "intradayTrailing") {
                setOrderInputs(curr => ({ ...curr, [name]: Math.min(isNaN(parseInt(curr[name])) ? 0 : parseInt(curr[name]) + 1, ORDER_ENTRY_CONSTANTS.QUANTITY_MAX_RANGE) }));
            }
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
            else if (name === "discQty") {
                if (scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES) {
                    var nMaxDiscQty = parseInt(orderInputs?.scripQuantity);
                } else {
                    nMaxDiscQty = parseInt(orderInputs?.scripLot);
                }
                setOrderInputs(curr => ({ ...curr, [name]: Math.min(isNaN(parseInt(curr[name])) ? 0 : parseInt(curr[name]) + 1, nMaxDiscQty) }));
            }
            else if (name === "protPercent") {
                setOrderInputs(curr => ({ ...curr, [name]: Math.min(isNaN(parseFloat(curr[name])) ? 0 : parseFloat(curr[name]) + 1, ORDER_ENTRY_CONSTANTS.PROTECTION_PERCENTAGE_MAX_RANGE) }));
            }
            else if (name === "numberOfInstallment") {
                if (activeTabKey === ORDER_TYPES.EQUITY_SIP) {
                    setOrderInputs(curr => ({ ...curr, [name]: Math.min(isNaN(parseFloat(curr[name])) ? sipSettingDetails?.frequency_details[selectOrderOption?.frequency]?.installment_min : parseFloat(curr[name]) + 1, sipSettingDetails?.frequency_details[selectOrderOption.frequency]?.installment_max) }));
                } else {
                    setOrderInputs(curr => ({ ...curr, [name]: Math.min(isNaN(parseFloat(curr[name])) ? 0 : parseFloat(curr[name]) + 1, ORDER_ENTRY_CONSTANTS.NUMBER_OF_INSTALLMENT_MAX_RANGE) }));
                }
            }
            else {
                setOrderInputs(curr => {
                    const nRoundedPrice = roundToNearest(parseFloat(curr[name]), scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], 'up');
                    let nMaxValue = Math.min(isNaN(nRoundedPrice) ? 0 : nRoundedPrice + scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], ORDER_ENTRY_CONSTANTS.PRICE_MAX_RANGE);
                    let PriceinPaise = parseInt(Math.round(parseFloat((nMaxValue * scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]).toString())).toString());
                    let selPriceTick = scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK] * scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
                    if (PriceinPaise % parseInt(selPriceTick) !== 0) {
                        //Price correction to nearest value.
                        nMaxValue = (parseFloat(nMaxValue) - (PriceinPaise % parseInt(selPriceTick)) / parseInt(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]));
                    }
                    return { ...curr, [name]: isNaN(parseFloat(curr[name])) ? 0 : getToFixedParseFloat(nMaxValue, scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) };
                });
            }
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End

        } else if (upDown === 'decrease') {

            if (name === "capPrice") {

                setOrderInputs(curr => ({ ...curr, [name]: Math.max(parseFloat(curr[name]) - 1, 0) }));

            } else if (name === "numberOfInstallment") {
                if (activeTabKey === ORDER_TYPES.EQUITY_SIP) {
                    setOrderInputs(curr => ({ ...curr, [name]: Math.max(parseFloat(curr[name]) - 1, sipSettingDetails?.frequency_details[selectOrderOption?.frequency]?.installment_min) }));
                } else {
                    setOrderInputs(curr => ({ ...curr, [name]: Math.max(parseFloat(curr[name]) - 1, 0) }));
                }
            } else if (name === "scripLot") {
                let nLot = parseInt(isNaN(orderInputs?.scripLot) ? 0 : orderInputs?.scripLot);
                nLot = Math.max((nLot - 1), 0);
                const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
                setOrderInputs(curr => ({ ...curr, [name]: nLot, scripQuantity: parseInt(nLot * nScripReularLot) }));
            }
            else if (name === "scripAmount") {
                let nAmount = isNaN(parseFloat(orderInputs.scripAmount)) ? 0 : parseFloat(orderInputs.scripAmount);
                nAmount = Math.max(nAmount - 1, 0);
                const nLot = calculateQuantityAsPerAmount(nAmount);
                const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
                setOrderInputs(curr => ({ ...curr, [name]: nAmount, scripQuantity: parseInt(nLot * nScripReularLot), scripLot: nLot }));
            }
            else if (name === "scripQuantity") {
                let nScripQuantity = parseInt(isNaN(orderInputs?.scripQuantity) ? 0 : orderInputs?.scripQuantity);
                const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
                if (nScripQuantity % nScripReularLot === 0) {
                    nUpdatedScripQuantity = parseInt((nScripQuantity - nScripReularLot));
                } else {
                    nUpdatedScripQuantity = parseInt(Math.floor(nScripQuantity / nScripReularLot) * nScripReularLot);
                }
                nUpdatedScripQuantity = Math.max(nUpdatedScripQuantity, 0);
                let nUpdatedLot = parseInt(Math.round(nUpdatedScripQuantity / nScripReularLot));
                setOrderInputs(curr => ({ ...curr, scripLot: nUpdatedLot, [name]: nUpdatedScripQuantity }));
            }
            else if (name === "quantity" || name === "intradayTrailing") {
                setOrderInputs(curr => ({ ...curr, [name]: Math.max(isNaN(parseInt(curr[name])) ? 0 : parseInt(curr[name]) - 1, 0) }));
            }
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
            else if (name === "discQty") {
                setOrderInputs(curr => ({ ...curr, [name]: Math.max(isNaN(parseInt(curr[name])) ? 0 : parseInt(curr[name]) - 1, 0) }));
            }
            else if (name === "protPercent") {
                setOrderInputs(curr => ({ ...curr, [name]: Math.max(isNaN(parseFloat(curr[name])) ? 0 : parseFloat(curr[name]) - 1, 0) }));
            }
            else {
                if (parseFloat(orderInputs[name]) <= 0) {
                    setOrderInputs(curr => {
                        return {
                            ...curr, [name]: isNaN(curr[name]) ? 0 : getToFixedParseFloat(0, scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])
                        };
                    });
                } else {
                    setOrderInputs(curr => {
                        let nMinValue = roundToNearest(parseFloat(curr[name]), scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], 'down') - scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK];
                        let PriceinPaise = parseInt(Math.round(parseFloat((nMinValue * scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]).toString())).toString());
                        let selPriceTick = scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK] * scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
                        if (PriceinPaise % parseInt(selPriceTick) !== 0) {
                            //Price correction to nearest value.
                            nMinValue = (parseFloat(nMinValue) - (PriceinPaise % parseInt(selPriceTick)) / parseInt(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]));
                        }
                        return {
                            ...curr, [name]: isNaN(curr[name]) ? 0 : getToFixedParseFloat(nMinValue, scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])
                        };
                    });
                }
            }
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End

        }
    }, [scripOrderInfo, orderInputs, calculateQuantityAsPerAmount]);

    const marginInfoHandler = useCallback((strProductType, nQuantity) => {
        let nPrice = parseFloat(orderInputs.scripPrice);
        if (toggleBracketOrder?.isShow) {
            if (!isNaN(parseFloat(orderInputs?.intradayLimit)) && parseFloat(orderInputs?.intradayLimit) > 0) {
                nPrice = parseFloat(orderInputs?.intradayLimit);
            } else {
                nPrice = 0;
            }
        } else {
            nPrice = parseFloat(orderInputs.scripPrice);
        }
        if (strProductType && typeof strProductType == 'string') {
            strProductType = getProductTypeValue(strProductType?.toUpperCase()) || '';
        } else {
            strProductType = getProductTypeValue(selectOrderOption?.productType?.toUpperCase()) || '';
        }
        if (!isNaN(parseInt(orderInputs.scripQuantity)) && parseInt(nQuantity) > 0) {
            nQuantity = parseInt(nQuantity);
        } else {
            if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES || scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_DERIVATIVES || scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES) {
                nQuantity = orderInputs.scripQuantity;
            } else {
                nQuantity = orderInputs.scripLot;
            }
        }
        if (!(activeTabKey === ORDER_TYPES.MULTI_SCRIP && multiScripOrderActiveTabKey === ORDER_TYPES.BASKET)) {
            const arrLegDetails = [
                {
                    "LegNo": 1,
                    "BuyOrSell": activeButtonToggleIndex + 1,
                    "MarketSegmentId": scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID],
                    "Token": scripOrderInfo?.[WATCHLIST_GRID_INDEX.TOKEN],
                    "Quantity": nQuantity,
                    "Price": Math.round(nPrice * scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]),
                    "MktFlag": selectOrderOption?.orderType?.includes('MKT') ? 1 : 0,
                    "OldPrice": 0,
                    "OldQuantity": 0,
                    "ProductType": strProductType,
                    "LegIndicator": 0
                }
            ];
            dispatch(getOrderMarginInfo(arrLegDetails));
        }
        else {
            orderEntryMultiScripRef?.current?.handleMarginInfo(arrOrderCartVertical);
        }
    }, [activeButtonToggleIndex, dispatch, orderInputs, scripOrderInfo, selectOrderOption, toggleBracketOrder, arrOrderCartVertical]);
    useEffect(() => {
        if (arrMarginInfo?.ApproxMargin && scripOrderInfo?.length > 0) {
            if (scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_DERIVATIVES || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES || ((scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_CASH || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSE_CASH) && scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT].toUpperCase() === SCRIP_INSTRUMENTS.EQUITIES && scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT] > 1)) {
                // nFundsRequiredPerLot = (parseFloat(arrMarginInfo?.ApproxMargin) * scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT]) / scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT];
                nFundsRequiredPerLot = (parseFloat(arrMarginInfo?.ApproxMargin) * scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT]) / orderInputs.scripQuantity;
            } else {
                // nFundsRequiredPerLot = parseFloat(arrMarginInfo?.ApproxMargin) / scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT];
                nFundsRequiredPerLot = parseFloat(arrMarginInfo?.ApproxMargin) / orderInputs.scripLot;
            }
        } else { }
    }, [arrMarginInfo, scripOrderInfo]);

    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

    //Maaz A : 01-12-2023 : BT-102298 - Breeze - Single Scrip Order entry - GTD Bug Fixes - Start
    const strSelectedExchName = useMemo(() => getApiExchangeNameFromMktSegId(scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]), [scripOrderInfo]);
    const validityTypes = useMemo(() => {
        const arrSelectedExchangeValidity = getValidityByExchangeName(strSelectedExchName);
        if (arrSelectedExchangeValidity?.length > 0) {
            var arrFinalValidity = arrSelectedExchangeValidity.filter(strValidity => _isShowValidityOrderEntry(scripOrderInfo, strValidity, selectOrderOption, false, objCFT?.GTTSUPPORT === FACILITY_NUM.ON));// Azeem K:07-05 - 2025 : added conditionally GTT and GTD
        } else {
            arrFinalValidity = arrSelectedExchangeValidity;
        }
        if (arrFinalValidity?.length > 0) {
            handleOnSelectOrderOptionChange({ target: { name: 'validityTypes', value: arrFinalValidity[0] } });
        }
        return arrFinalValidity;
    }, [strSelectedExchName, scripOrderInfo, selectOrderOption?.productType, selectOrderOption?.orderType, objCFT]);
    //Maaz A : 01-12-2023 : BT-102298 - Breeze - Single Scrip Order entry - GTD Bug Fixes - End


    //PrachiTawde : 05-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - Start
    const onValueClick = (value) => {
        const nValue = parseFloat(value);
        setOrderInputs(curr => ({ ...curr, scripPrice: nValue, capPrice: nValue.toFixed(scripData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) })); //BT-142330 :Hotfix Bug fixing : ManasaB : 27-08-2024 : Order SIP Market Depth issue

    };

    const handleFortnightlyFrequencyChange = (e) => {
        const { value } = e.target;
        setSelectOrderOption(curr => ({ ...curr, selectSpecificFrequencyDate: value }));
    };


    const arrPlaceOrderInfo = useMemo(() => [
        {
            id: 1,
            scrip: "SingleScrip",
            tabKey: ORDER_TYPES.SINGLE_SCRIP,
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
            tableContent: <OrderSingleScrip ref={orderEntrySingleScripRef} isScripPrice={isScripPrice} setIsScripPrice={setIsScripPrice} layoutType={LAYOUT_TYPE.VERTICAL} handleOrderInputs={handleOrderInputs} handleOrderStepsOnChange={handleOrderStepsOnChange} orderInputs={orderInputs} scripOrderInfo={scripOrderInfo} toggleBracketOrder={toggleBracketOrder} arrAllExchangeWiseProductTypes={arrAllExchangeWiseProductTypes}
                setArrAllExchangeWiseProductTypes={setArrAllExchangeWiseProductTypes} marginInfoHandler={marginInfoHandler}
                setToggleBracketOrder={setToggleBracketOrder} isHeader={false} activeButtonToggleIndex={activeButtonToggleIndex} selectOrderOption={selectOrderOption} handleOnSelectOrderOptionChange={handleOnSelectOrderOptionChange} validityTypes={validityTypes}
                setSelectOrderOption={setSelectOrderOption} setOrderInputs={setOrderInputs} setIsExpanded={setIsExpanded} />,
            tableHeader: <OrderSingleScrip ref={orderEntrySingleScripRef} isScripPrice={isScripPrice} setIsScripPrice={setIsScripPrice} layoutType={LAYOUT_TYPE.VERTICAL} handleOrderInputs={handleOrderInputs} handleOrderStepsOnChange={handleOrderStepsOnChange} orderInputs={orderInputs} scripOrderInfo={scripOrderInfo} toggleBracketOrder={toggleBracketOrder} arrAllExchangeWiseProductTypes={arrAllExchangeWiseProductTypes}
                setArrAllExchangeWiseProductTypes={setArrAllExchangeWiseProductTypes} marginInfoHandler={marginInfoHandler}
                setToggleBracketOrder={setToggleBracketOrder} isHeader={true} activeButtonToggleIndex={activeButtonToggleIndex} selectOrderOption={selectOrderOption} handleOnSelectOrderOptionChange={handleOnSelectOrderOptionChange} validityTypes={validityTypes}
                setSelectOrderOption={setSelectOrderOption} setOrderInputs={setOrderInputs} setIsExpanded={setIsExpanded} />
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
        },
        //Maaz A : 17-11-2023 : Client Facility Template - Added for MultiLeg and Spread - Start
        ((objCFT.MULTILEG === FACILITY_NUM.ON || objCFT.BULKORDER === FACILITY_NUM.ON) && config.bIsProd === 'false') &&
        {
            id: 2,
            scrip: "MultiScrip",
            tabKey: "multi_scrip",
            tableContent: <OrderMultiScrip ref={orderEntryMultiScripRef} layoutType={LAYOUT_TYPE.VERTICAL} scripOrderInfo={scripOrderInfo} setMultiScripOrderActiveTabKey={setMultiScripOrderActiveTabKey} multiScripOrderActiveTabKey={multiScripOrderActiveTabKey} activeTabKey={activeTabKey} setBIsShowCreateCart={setBIsShowCreateCart} setBIsPlaceOrderBtnDisabled={setBIsPlaceOrderBtnDisabled} bIsPlaceOrderBtnDisabled={bIsPlaceOrderBtnDisabled} bIsConfirmBack={bIsConfirmBack} bIsSaveCartBack={bIsSaveCartBack} arrAllExchangeWiseProductTypes={arrAllExchangeWiseProductTypes} setArrAllExchangeWiseProductTypes={setArrAllExchangeWiseProductTypes} activeButtonToggleIndex={activeButtonToggleIndex} setIsExpanded={setIsExpanded} />, //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024
        },
        (config.bIsProd === 'false') &&
        {
            id: 3,
            scrip: "SIP",
            tabKey: ORDER_TYPES.EQUITY_SIP,
            tableHeader: <OrderSip isVertical={true} setSelectOrderOption={setSelectOrderOption} handleFortnightlyFrequencyChange={handleFortnightlyFrequencyChange} setOrderInputs={setOrderInputs} setOrderEntryTab={setActiveTabKey} layoutType={LAYOUT_TYPE.VERTICAL} orderInputs={orderInputs} handleOrderInputs={handleOrderInputs} handleOrderStepsOnChange={handleOrderStepsOnChange} selectSpecificFrequencyDate={selectSpecificFrequencyDate} currentDate={currentDate} handleOnSelectOrderOptionChange={handleOnSelectOrderOptionChange} selectOrderOption={selectOrderOption} scripOrderInfo={scripOrderInfo} activeButtonToggleIndex={activeButtonToggleIndex} bIsSipAllowed={bIsSipAllowed} />,
            // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - Start
            tableContent: <OrderSip isVertical={false} setSelectOrderOption={setSelectOrderOption} handleFortnightlyFrequencyChange={handleFortnightlyFrequencyChange} setOrderInputs={setOrderInputs} setOrderEntryTab={setActiveTabKey} layoutType={LAYOUT_TYPE.VERTICAL} orderInputs={orderInputs} handleOrderInputs={handleOrderInputs} handleOrderStepsOnChange={handleOrderStepsOnChange} selectSpecificFrequencyDate={selectSpecificFrequencyDate} currentDate={currentDate} handleOnSelectOrderOptionChange={handleOnSelectOrderOptionChange} selectOrderOption={selectOrderOption} scripOrderInfo={scripOrderInfo} activeButtonToggleIndex={activeButtonToggleIndex} bIsSipAllowed={bIsSipAllowed} />
            // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - End
        }
    ], [currentDate, handleOnSelectOrderOptionChange, validityTypes, objCFT, arrAllExchangeWiseProductTypes, handleOrderInputs, marginInfoHandler, handleOrderStepsOnChange, multiScripOrderActiveTabKey, orderInputs, scripOrderInfo, selectOrderOption, toggleBracketOrder, selectSpecificFrequencyDate, activeButtonToggleIndex]);
    //Maaz A : 17-11-2023 : Client Facility Template - Added for MultiLeg and Spread - End

    const onViewBrokerageAndCharges = () => {
        if (scripOrderInfo?.length) {
            dispatch(handleModal([{ 'BROKERAGE_CHARGES_MODAL': true }]));
        }
        else {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: "Please select a scrip!" }));
        }
    };

    const handlePlaceOrderSingleScrip = () => {
        orderEntrySingleScripRef?.current?.handlePlaceOrderButton();
    };
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start
    const handleSaveCartAndPlaceOrderBtn = () => {
        orderEntryMultiScripRef?.current?.handleOpenOrderNameModal();
    };
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End
    useEffect(() => {
        if (bIsSingleScripOrderConfirmed) {
            dispatch(setShowSideTrayPlaceOrder(false));
            dispatch(setShowSideOrderConfirmation(true));
        } else { }
    }, [bIsSingleScripOrderConfirmed]);


    // Ajitesh Fn to check restrictive or infomrative LTP ptice band
    const getValidateLTPPriceBand = () => {
        let nTriggerPrice = parseFloat(orderInputs?.intradayTrigger);
        const legsThatHaveLtpPriceValidationError = [];
        if (selectOrderOption?.orderType?.includes(ORDER_ENTRY_TYPES.SL) && !isNaN(parseFloat(orderInputs?.slTrigger)) && parseFloat(orderInputs?.slTrigger) > 0) {
            nTriggerPrice = parseFloat(orderInputs?.slTrigger);
        } else {
            nTriggerPrice = parseFloat(orderInputs?.intradayTrigger);
        }
        // Loop over all legs in multileg order entry
        multiLegData?.forEach((eachLeg) => {
            const objLtpValid = validateLTPPriceBand(scripOrderInfo, scripOrderInfo?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE], eachLeg.activeButtonToggleIndex, parseFloat(eachLeg?.legPrice), selectOrderOption?.orderType, ltpPriceBandMaster, nTriggerPrice);
            // if ltp price band validation happens
            if (!objLtpValid?.valid) {
                if (objLtpValid?.isRestrictive) {
                    // push to array with error message and mode of isRestrictive
                    legsThatHaveLtpPriceValidationError.push({ ...eachLeg, errorMsgToShow: objLtpValid.errorMsg, isRestrictive: true });
                } else {
                    // push to array with error message and mode of isInformative
                    legsThatHaveLtpPriceValidationError.push({ ...eachLeg, errorMsgToShow: objLtpValid.errorMsg, isInformative: true });
                }
            }
        });
        // If there was any price validation error in any leg then modal opens and below condition executes
        if (legsThatHaveLtpPriceValidationError.length) {
            dispatch(updateMultiLegOrderConfirmed(false));
            setLegsThatFailLtpPriceValidation(legsThatHaveLtpPriceValidationError);
            dispatch(handleModal([{ "LTP_PRICE_BAND_VALIDATION_ERROR_MODAL": true }]));
            return false;
        }
        // else order confirms
        else {
            dispatch(updateMultiLegOrderConfirmed(true));
            return true;
        }
    };

    // Ajitesh Fn that handles Yes/No when surveillance msg is shown if scrip is in surveillance
    const survelienceConfirmationHandler = useCallback((nUserResp, scripInfo) => {
        dispatch(setCautionaryMessageFromPopup(nUserResp, scripInfo[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION], scripInfo[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripInfo[WATCHLIST_GRID_INDEX.TOKEN]));
        dispatch(toastConfig({ show: false }));
        if (nUserResp === 1) {
            return getValidateLTPPriceBand();
        } else {
            dispatch(toastConfig({ show: false }));
            return true;
        }
    }, [dispatch, getValidateLTPPriceBand]);

    // Handle order validations for mulitleg sidetray
    const handleMultilegSidetrayOrderValidations = () => {
        //let orderValidationStatus = false;
        if (scripOrderInfo && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] !== 0 && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION]) { //Parshva S : 5/4/24 : BT 102679 Mltileg Order
            let strMsg = getGSMGradeDescriptionFromScrip(scripOrderInfo);
            if (strMsg) {
                dispatch(toastConfig({ show: true, message: strMsg, button: [{ btnName: "Yes", className: "btn btn-solid ms-3", onClickHandler: (e) => survelienceConfirmationHandler(SURV_MEASURE_POPUP_ACTION.YES, scripOrderInfo) }, { btnName: "No", className: "btn btn-outline-active ms-3", onClickHandler: (e) => survelienceConfirmationHandler(SURV_MEASURE_POPUP_ACTION.NO, scripOrderInfo) }] }));
                //return false;
            } else { }
        }
        else {
            // Ajitesh 02-07-2024 Validation for price tick in multileg
            if (multiLegData.length) {
                for (let i = 0; i < multiLegData.length; i++) {
                    if (multiLegData[i].orderType === ORDER_ENTRY_TYPES.RL) {
                        // Price tick
                        const scripTickValue = multiLegData[i]?.priceTick * multiLegData[i]?.decLoc;
                        // Decimal locator
                        const DecimalLocator = multiLegData[i]?.decLoc;
                        const PriceinPaise = parseInt(Math.round(parseFloat((multiLegData[i].legPrice * DecimalLocator))));
                        if (PriceinPaise % parseInt(scripTickValue) !== 0) {
                            const PriceTickInRs = (parseFloat(scripTickValue / DecimalLocator).toFixed(multiLegData[i]?.decimalLocatorLength)); // use new decimal locator length field of specific leg
                            dispatch(toastConfig({ autoDismiss: true, timer: 5000, show: true, message: MSG_MASTER.NNSL62 + PriceTickInRs }));
                            return false;
                        }
                        // Check if user enters price as 0 which is not allowed
                        if (isNaN(parseFloat(multiLegData[i].legPrice)) || parseFloat(multiLegData[i].legPrice) === 0) {
                            dispatch(toastConfig({ autoDismiss: true, timer: 5000, show: true, message: MSG_MASTER.NNSL86 }));
                            return false;
                        }
                    }
                }
            }

            // Ajitesh 02-07-2024 If price tick is proper only then validate ltp
            if (true) {
                return getValidateLTPPriceBand();
            }
            else { }
        }
        //return placeOrderSuccess;
    };

    // Ajitesh 09-10-2024 Modify function to show multileg order confirmation details when user clicks Place Order button for multileg order in side tray
    const handlePlaceSideOrder = useCallback((e) => {
        e?.preventDefault();
        switch (activeTabKey) {
            case ORDER_TYPES.SINGLE_SCRIP: {
                handlePlaceOrderSingleScrip();
                break;
            }
            case ORDER_TYPES.EQUITY_SIP: {
                if (isNaN(orderInputs.numberOfInstallment) || orderInputs?.numberOfInstallment > sipSettingDetails?.frequency_details[selectOrderOption?.frequency]?.installment_max || orderInputs?.numberOfInstallment < sipSettingDetails?.frequency_details[selectOrderOption?.frequency]?.installment_min) {

                    dispatch(toastConfig({ autoDismiss: true, show: true, message: `No of Installment should be between  ${sipSettingDetails?.frequency_details[selectOrderOption.frequency].installment_min} and ${sipSettingDetails?.frequency_details[selectOrderOption.frequency].installment_max}` }));
                }
                else if (orderInputs?.startDate < currentDate) {
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: 'start date should not be less than current date' }));
                }
                else if (isNaN(orderInputs.quantity) || orderInputs?.quantity < 1) {
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: 'Quantity Or Amount must be provided' }));

                }
                else {
                    dispatch(setShowSideTrayPlaceOrder(false));
                    dispatch(setShowSideOrderConfirmation(true));
                    setIsChecked(false);
                    // Hari K:31-07-2024:side try SIP order entry-start
                    dispatch(setShowSideTrayPlaceOrder(false));
                    dispatch(setShowSideOrderConfirmation(true));
                    setIsChecked(false);
                    dispatch(handleModalData({
                        data: {
                            layoutType: LAYOUT_TYPE.VERTICAL, orderEntryTab: 'sip',
                            activeButtonToggleIndex, scripOrderInfo,
                            selectOrderOption, orderInputs, objSelectOrderOptionInit,
                            isModifyOrder: false, isReOrder: false,
                        }
                    }));
                    // Hari K:31-07-2024:side try SIP order entry-end

                }
                break;
            }
            //Ameersha N : 25-08-2023 : BT-107070 - Breeze - Spread Order entry - Start
            case ORDER_TYPES?.MULTI_SCRIP: {
                //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start
                if (activeTabKey === ORDER_TYPES?.MULTI_SCRIP && multiScripOrderActiveTabKey === ORDER_TYPES?.SPREAD) {
                    let decLoc = '1'.padEnd(scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] + 1, 0);
                    let price = multiSpreadOrderInfo?.price * decLoc;
                    let priceTick = scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] * decLoc;
                    if (parseInt(Math.round(price) % parseInt(priceTick)) !== 0) {
                        dispatch(toastConfig({ autoDismiss: true, timer: 5000, show: true, message: MSG_MASTER.NNSL62 + scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] }));
                        return;
                    }
                    if (scripOrderInfo[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] && scripOrderInfo[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] !== "0") {
                        const strMsg = getGSMGradeDescriptionFromScrip(scripOrderInfo);
                        if (strMsg) {
                            dispatch(toastConfig({ show: true, message: strMsg, button: [{ btnName: "Yes", className: "btn btn-solid ms-3", onClickHandler: (e) => survelienceConfirmationHandler(SURV_MEASURE_POPUP_ACTION.YES, scripOrderInfo) }, { btnName: "No", className: "btn btn-outline-active ms-3", onClickHandler: () => survelienceConfirmationHandler(SURV_MEASURE_POPUP_ACTION.NO, scripOrderInfo) }] }));
                            return false;
                        } else { }
                    } else {
                        let nTriggerPrice = parseFloat(orderInputs?.intradayTrigger);
                        if (selectOrderOption?.orderType?.includes(ORDER_ENTRY_TYPES.SL) && !isNaN(parseFloat(orderInputs?.slTrigger)) && parseFloat(orderInputs?.slTrigger) > 0) {
                            nTriggerPrice = parseFloat(orderInputs?.slTrigger);
                        } else {
                            nTriggerPrice = parseFloat(orderInputs?.intradayTrigger);
                        }
                        const objLtpValid = validateLTPPriceBand(scripOrderInfo, scripOrderInfo[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE], activeButtonToggleIndex, parseFloat(multiSpreadOrderInfo?.price), selectOrderOption?.orderType, ltpPriceBandMaster, nTriggerPrice);
                        if (!objLtpValid?.valid) {
                            if (objLtpValid?.isRestrictive) {
                                dispatch(toastConfig({ show: true, message: objLtpValid?.errorMsg, button: [{ btnName: "Ok", className: "btn btn-solid ms-3", type: 'CLOSE' }] }));
                                return false;
                            } else {
                                dispatch(toastConfig({
                                    show: true, message: objLtpValid?.errorMsg, button: [{
                                        btnName: "Yes", className: "btn btn-solid ms-3", onClickHandler: () => {
                                            dispatch(handleSpreadSideOrder(true));
                                            dispatch(setShowSideTrayPlaceOrder(false));
                                            dispatch(setShowSideOrderConfirmation(true));
                                        }
                                    }, { btnName: "No", className: "btn btn-outline-active ms-3", type: 'CLOSE' }]
                                }));
                                return true;
                            }
                        } else {
                            dispatch(handleSpreadSideOrder(true));
                            dispatch(setShowSideTrayPlaceOrder(false));
                            dispatch(setShowSideOrderConfirmation(true));
                            return true;
                        }
                    }
                    // dispatch(getScripOrderInfo({ scripData: multiSpreadOrderInfo }));
                    return;
                }
                else if (activeTabKey === ORDER_TYPES?.MULTI_SCRIP && multiScripOrderActiveTabKey === ORDER_TYPES.BASKET) {
                    dispatch(setShowSideTrayPlaceOrder(false));
                    handleSaveCartAndPlaceOrderBtn();
                }
                // Ajitesh 09-10-2024 Modify condition to hide order details and show order confirmation window when user clicks place order btn in multileg sidetray
                else {
                    // Sidetray multileg order validations
                    let validationStatus = handleMultilegSidetrayOrderValidations();
                    if (validationStatus) {
                        dispatch(setShowSideTrayPlaceOrder(false));
                        dispatch(setShowSideOrderConfirmation(true));
                    }
                    else { }
                    break;
                }
                //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End
                break;
            }
            //Ameersha N : 25-08-2023 : BT-107070 - Breeze - Spread Order entry - End
            default:
                break;
        }
    }, [activeTabKey, orderInputs, multiSpreadOrderInfo, scripOrderInfo, sipSettingDetails?.frequency_details, selectOrderOption, currentDate, dispatch, activeButtonToggleIndex, multiScripOrderActiveTabKey, multiLegData]);

    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start

    const updateActiveButtonToggleIndex = useCallback((nIsBuyOrSell) => {
        dispatch(getScripOrderInfo({ isBuySell: nIsBuyOrSell, activeMktSegId, scripData: scripOrderInfo }));
    }, [activeMktSegId, scripOrderInfo, dispatch]);


    //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - Start
    useEffect(() => {
        if (orderQuantityCaption?.length > 0 && scripOrderInfo?.length > 0) {
            let objDefaultType = orderQuantityCaption?.find(obj => obj.isDefault);
            if (!objDefaultType?.type) {
                objDefaultType = orderQuantityCaption[0];
            } else { }
            handleOnSelectOrderOptionChange({ target: { name: 'orderBy', value: objDefaultType.type } });

            switch (objDefaultType.type) {
                case 'Lot': {
                    handleOrderInputs({ target: { name: 'scripLot', value: orderInputs?.scripLot } });
                    break;
                }
                case 'Quantity': {
                    handleOrderInputs({ target: { name: 'scripQuantity', value: orderInputs?.scripLot * scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT] } });
                    break;
                }
                case 'Amount': {
                    handleOrderInputs({ target: { name: 'scripAmount', value: '0' } });
                    break;
                }
                default:
                    break;
            }
        } else { }
    }, [orderQuantityCaption]);
    //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - End

    const handleOnConfirmSingleScripOrder = () => {
        //Azeem K : 12-07-2024 : BT-102298 - Breeze - Single Scrip SideTray Order entry  - Start
        if (scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.NSE_DERIVATIVES || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.NCDEX_DERIVATIVES
            || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.BSE_DERIVATIVES) {
            var nQuantity = orderInputs.scripQuantity;
        } else {
            nQuantity = orderInputs.scripLot;
        }
        let nDiscQty = orderInputs?.discQty;
        if (scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.NCDEX_DERIVATIVES) {
            nDiscQty = orderInputs?.discQty * scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT];
        }
        //Azeem K : 12-07-2024 : BT-102298 - Breeze - Single Scrip SideTray Order entry  - End

        const bIsCoverBracketOrderOpen = toggleBracketOrder?.isShow;

        if (scripOrderInfo?.length > 0) {
            const exchangeNameById = getApiExchangeNameFromMktSegId(scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
            if (selectOrderOption?.productType === ORDER_PRODUCT_TYPES.MARGIN) {
                var strSelProductType = ORDER_PRODUCT_TYPES.INTRADAY;
            } else if (selectOrderOption?.productType === ORDER_PRODUCT_TYPES.CARRYFORWARD) {
                strSelProductType = ORDER_PRODUCT_TYPES.DELIVERY;
            } else if (selectOrderOption?.productType === ORDER_PRODUCT_TYPES.PTST) {
                strSelProductType = ORDER_PRODUCT_TYPES.BTST;
            } else {
                strSelProductType = selectOrderOption?.productType;
            }

            if (bIsCoverBracketOrderOpen) {

                const nIntradayProfit = parseFloat(orderInputs?.intradayProfit);
                const nIntradayTrigger = parseFloat(orderInputs?.intradayTrigger);

                // for order status
                objOrderStatusScripData = {
                    scrip_info: {
                        exchange: exchangeNameById,
                        scrip_token: scripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN],
                        symbol: scripOrderInfo[WATCHLIST_GRID_INDEX.SYMBOL],
                        series: scripOrderInfo[WATCHLIST_GRID_INDEX.SERIES],
                        expiry_date: scripOrderInfo[WATCHLIST_GRID_INDEX.EXPIRYDATE],
                        strike_price: scripOrderInfo[WATCHLIST_GRID_INDEX.STRIKEPRICE],
                        option_type: scripOrderInfo[WATCHLIST_GRID_INDEX.OPTIONTYPE]
                    },
                    transaction_type: activeButtonToggleIndex === 0 ? 'BUY' : 'SELL',
                    product_type: strSelProductType,
                    order_type: selectOrderOption?.orderType,
                    quantity: nQuantity,
                    price: parseFloat(orderInputs?.scripPrice),
                    trigger_price: parseFloat(orderInputs?.slTrigger),
                    intradayTrigger: nIntradayTrigger,
                    intradayProfit: nIntradayProfit,
                    intradayLimit: parseFloat(orderInputs?.intradayLimit),
                    intradayTrailing: parseInt(orderInputs?.intradayTrailing),
                    coverOrBracket: ''
                };


                if (!isNaN(nIntradayProfit) && nIntradayProfit > 0) {
                    // Bracker Order Request
                    objOrderStatusScripData.coverOrBracket = ORDER_PRODUCT_TYPES.BRACKET;
                    const objBracketOrderRequest = {
                        scrip_info: {
                            exchange: exchangeNameById,
                            scrip_token: scripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN],
                            symbol: scripOrderInfo[WATCHLIST_GRID_INDEX.SYMBOL],
                            series: scripOrderInfo[WATCHLIST_GRID_INDEX.SERIES],
                            expiry_date: scripOrderInfo[WATCHLIST_GRID_INDEX.EXPIRYDATE],
                            strike_price: scripOrderInfo[WATCHLIST_GRID_INDEX.STRIKEPRICE],
                            option_type: scripOrderInfo[WATCHLIST_GRID_INDEX.OPTIONTYPE]
                        },
                        transaction_type: activeButtonToggleIndex === 0 ? 'BUY' : 'SELL',
                        main_leg: {
                            order_type: selectOrderOption?.orderType,
                            quantity: nQuantity,
                            price: parseFloat(orderInputs?.scripPrice) ? parseFloat(orderInputs?.scripPrice) : 0,
                            trigger_price: parseFloat(orderInputs?.slTrigger) ? parseFloat(orderInputs?.slTrigger) : 0,
                        },
                        stoploss_leg: {
                            legs: [
                                {
                                    quantity: nQuantity,
                                    price: parseFloat(orderInputs?.intradayLimit) ? parseFloat(orderInputs?.intradayLimit) : 0,
                                    trigger_price: nIntradayTrigger
                                }
                            ],
                            trail: {
                                ltp_jump_price: 0,
                                stoploss_jump_price: parseInt(orderInputs?.intradayTrailing) ? parseInt(orderInputs?.intradayTrailing) : 0,
                            }
                        },
                        profit_leg: {
                            legs: [
                                {
                                    quantity: nQuantity,
                                    price: nIntradayProfit,
                                }
                            ]
                        },
                        order_identifier: getOrderIdentifier(),
                    };

                    dispatch(placeSingleScripBracketOrder(objBracketOrderRequest));

                } else if (!isNaN(nIntradayTrigger) && nIntradayTrigger > 0) {
                    // Cover Order Request
                    objOrderStatusScripData.coverOrBracket = ORDER_PRODUCT_TYPES.COVER;
                    const objCoverOrderRequest = {
                        scrip_info: {
                            exchange: exchangeNameById,
                            scrip_token: scripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN],
                            symbol: scripOrderInfo[WATCHLIST_GRID_INDEX.SYMBOL],
                            series: scripOrderInfo[WATCHLIST_GRID_INDEX.SERIES],
                            expiry_date: scripOrderInfo[WATCHLIST_GRID_INDEX.EXPIRYDATE],
                            strike_price: scripOrderInfo[WATCHLIST_GRID_INDEX.STRIKEPRICE],
                            option_type: scripOrderInfo[WATCHLIST_GRID_INDEX.OPTIONTYPE]
                        },
                        transaction_type: activeButtonToggleIndex === 0 ? 'BUY' : 'SELL',
                        main_leg: {
                            order_type: selectOrderOption?.orderType,
                            quantity: nQuantity,
                            price: parseFloat(orderInputs?.scripPrice) ? parseFloat(orderInputs?.scripPrice) : 0,
                        },
                        stoploss_leg: {
                            legs: [
                                {
                                    quantity: nQuantity,
                                    price: parseFloat(orderInputs?.intradayLimit) ? parseFloat(orderInputs?.intradayLimit) : 0,
                                    trigger_price: nIntradayTrigger
                                }
                            ]
                        },
                        order_identifier: getOrderIdentifier(),
                    };
                    dispatch(placeSingleScripCoverOrder(objCoverOrderRequest));
                } else { }
            } else {
                const objSingleScripRequest = {
                    scrip_info: {
                        exchange: exchangeNameById,
                        scrip_token: scripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN],
                        symbol: scripOrderInfo[WATCHLIST_GRID_INDEX.SYMBOL],
                        series: scripOrderInfo[WATCHLIST_GRID_INDEX.SERIES],
                        expiry_date: scripOrderInfo[WATCHLIST_GRID_INDEX.EXPIRYDATE],
                        strike_price: scripOrderInfo[WATCHLIST_GRID_INDEX.STRIKEPRICE],
                        option_type: scripOrderInfo[WATCHLIST_GRID_INDEX.OPTIONTYPE]
                    },
                    transaction_type: activeButtonToggleIndex === 0 ? 'BUY' : 'SELL',
                    product_type: strSelProductType,
                    order_type: selectOrderOption?.orderType,
                    quantity: nQuantity,
                    price: selectOrderOption?.orderType === ORDER_ENTRY_TYPES.SL || selectOrderOption?.orderType === ORDER_ENTRY_TYPES.RL ? parseFloat(orderInputs?.scripPrice) : 0,
                    trigger_price: selectOrderOption?.orderType?.includes(ORDER_ENTRY_TYPES.SL) || selectOrderOption?.validityTypes == ORDER_VALIDITY.GTT ? parseFloat(orderInputs?.slTrigger) : 0,//BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025
                    disclosed_quantity: parseInt(nDiscQty),
                    validity: selectOrderOption?.validityTypes,
                    validity_days: selectOrderOption?.validityTypes === ORDER_VALIDITY.GTD ? nGTDNoOfDays : 0,
                    is_amo: selectOrderOption?.isAmo,
                    order_identifier: getOrderIdentifier(),
                };
                // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --Start
                if (selectOrderOption?.isOCOChecked) {
                    objSingleScripRequest.price_firstleg = parseFloat(orderInputs?.targetSelPrice);
                    objSingleScripRequest.price_secondleg = parseFloat(orderInputs?.targetSelTriggerPrice);
                }
                // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --End
                objOrderStatusScripData = objSingleScripRequest;
                dispatch(placeSingleScripOrder(objSingleScripRequest));
            }

            // setIsChecked(!isChecked);
        }
    };

    useEffect(() => {
        if (objSingleScripOrderResp?.status === API_RESPONSE_STATUS.SUCCESS) {
            dispatch(setShowSideTrayPlaceOrder(false));
            dispatch(setShowSideOrderConfirmation(false));
            dispatch(setShowSideTrayOrderstatus(true));
        } else { }
    }, [dispatch, objSingleScripOrderResp]);
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start
    useEffect(() => {
        //ManasaB : 21-10-2024 ; Side tray order cart changes - Start

        if (Object.keys(objOrderCartOrderResp).length > 0) {
            if (objOrderCartOrderResp?.status === API_RESPONSE_STATUS.SUCCESS) {
                dispatch(setShowSideTrayPlaceOrder(false));
                dispatch(setShowSideOrderConfirmation(false));
                dispatch(setShowSideTrayOrderstatus(true));
                setOrderCartName(objOrderCartOrderResp.ordercartName);
            } else {

            }
        }
        //ManasaB : 21-10-2024 ; Side tray order cart changes - End
    }, [objOrderCartOrderResp]);
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End
    const handleOnCofirmSipOrder = () => {
        // dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': false }, { 'ORDER_STATUS': true }], true));
        // dispatch(handleModalData({ data: { orderInputs: modalData?.orderInputs, orderEntryTab: modalData?.orderEntryTab, selectOrderOption: modalData?.selectOrderOption, orderEntryTab: modalData?.orderEntryTab } }));
        // setBIsConfirmBtn(curr => !curr);
        // if (modalData?.isEdit) {
        //     const updateSipData = {

        //         basket_name: "",
        //         cap_price: 1000,
        //         company_name: "",
        //         frequency_details: {
        //             frequency_days: "",
        //             frequency_monthly_option: "DATE",
        //             frequency_specific_date: "2",
        //             frequency_start_date: modalData?.startDate,
        //             frequency_type: modalData?.selectOrderOption?.frequency,
        //             no_of_installments: modalData?.orderInputs?.numberOfInstallment
        //         },

        //         invested_by: modalData?.selectOrderOption?.orderBy === "Amount" ? "VALUE" :
        //             selectOrderOption?.orderBy?.toUpperCase(),
        //         ltp: "153.55",
        //         quantity_or_value: modalData?.orderInputs?.quantity,
        //         scrip_info: {
        //             exchange: getApiExchangeNameFromMktSegId(modifyOrderScripOrderInfo?.scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID]),
        //             expiry_date: "",
        //             option_type: "",
        //             scrip_token: modifyOrderScripOrderInfo?.scripData[WATCHLIST_GRID_INDEX.TOKEN],
        //             series: modifyOrderScripOrderInfo?.scripData[WATCHLIST_GRID_INDEX.SERIES],
        //             strike_price: "",
        //             symbol: modifyOrderScripOrderInfo?.scripData[WATCHLIST_GRID_INDEX.SYMBOL]
        //         },
        //         sip_id: orderInfo?.id,
        //         status: ALL_ORDERS_STATUS?.ORDER_STATUS_OPEN,
        //         transaction_type: modifyOrderScripOrderInfo?.isBuySell === 0 ? 'BUY' : 'SELL'
        //     };

        //     dispatch(updateSipOrder(updateSipData));

        // } else {
        // Vinit Raut : 25-04-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing -- Start
        const frequencySpecificDate = dayjs(orderInputs?.startDate)?.format('DD-MM-YYYY');
        // Vinit Raut : 25-04-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing -- End
        const objSipReqPayload = {
            scrip_info: {
                exchange: getApiExchangeNameFromMktSegId(scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID]),
                scrip_token: scripOrderInfo?.[WATCHLIST_GRID_INDEX.TOKEN],
                symbol: scripOrderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL],
                series: scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES],
                expiry_date: "",
                strike_price: "",
                option_type: ""
            },
            // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 -- Start
            frequency_details: {
                frequency_type: selectOrderOption?.frequency,
                frequency_days: selectOrderOption?.frequency === FREQUENCY_TYPE.WEEKLY ? selectOrderOption?.everyForWeekly : "",   // BT-107418 - Vinit R - 28/03/2024 Breeze SIP order Book
                frequency_start_date: frequencySpecificDate, // Vinit Raut : 25-04-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing
                frequency_specific_date: (selectOrderOption?.frequency === FREQUENCY_TYPE.FORTHNIGHTLY || selectOrderOption?.frequency === FREQUENCY_TYPE.MONTHLY) ? (selectOrderOption?.day_date === 'Date' || selectOrderOption?.day_date === "Day") ? selectOrderOption?.selectSpecificFrequencyDate : '1' : "",
                frequency_monthly_option: selectOrderOption?.frequency === FREQUENCY_TYPE.MONTHLY ? MONTHLY_SIP_OPTIONS.DATE : "",
                no_of_installments: parseInt(orderInputs?.numberOfInstallment)
            },
            company_name: "",
            ltp: scripOrderInfo?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE],
            cap_price: String(orderInputs?.capPrice),
            invested_by: selectOrderOption?.orderBy === "Amount" ? "VALUE" :
                selectOrderOption?.orderBy.toUpperCase(),
            quantity_or_value: String(orderInputs?.quantity),
            transaction_type: activeButtonToggleIndex === 0 ? 'BUY' : 'SELL',
            status: ALL_ORDERS_STATUS.ORDER_STATUS_PENDING,
            basket_name: "",
            sip_id: ""
            // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 -- End
        };

        objOrderStatusScripData = {
            scrip_info: {
                exchange: getApiExchangeNameFromMktSegId(scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID]),
                scrip_token: scripOrderInfo?.[WATCHLIST_GRID_INDEX.TOKEN],
                symbol: scripOrderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL],
                series: scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES],
                expiry_date: "",
                strike_price: "",
                option_type: ""
            },
            selectOrderOption,
            transaction_type: activeButtonToggleIndex === 0 ? 'BUY' : 'SELL',
            product_type: '',
            order_type: selectOrderOption?.orderType,
            quantity: orderInputs?.scripQuantity,
            // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 -- Start
            price: parseFloat(orderInputs?.scripPrice),
            quantity: orderInputs?.quantity,
            cap_price: String(orderInputs?.capPrice),
            no_of_installments: parseInt(orderInputs?.numberOfInstallment)
            // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 -- End
        };

        dispatch(placeSipOrder(objSipReqPayload));
        // }


    };

    useEffect(() => {
        // For SIP Response Handling
        if (objSipOrderResp?.status === API_RESPONSE_STATUS.SUCCESS) {
            dispatch(setShowSideTrayPlaceOrder(false));
            dispatch(setShowSideOrderConfirmation(false));
            dispatch(setShowSideTrayOrderstatus(true));
        } else { }
    }, [dispatch, objSipOrderResp]);

    // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - Start
    useEffect(() => {
        if (activeTabKey === ORDER_TYPES.EQUITY_SIP && activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.SELL) {
            updateActiveButtonToggleIndex(ORDER_ENTRY_BUTTON_TOGGLE.BUY);
        }
    }, [activeTabKey, activeButtonToggleIndex]);
    // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - End


    const handlePlaceNewOrder = () => {
        dispatch(setShowSideOrderConfirmation(false));
        dispatch(setShowSideTrayOrderstatus(false));
        dispatch(setShowSideTrayPlaceOrder(true));
        setOrderInputs({
            scripQuantity: 1, scripLot: 1, scripAmount: 0, scripPrice: '', slTrigger: 0, quantity: 0, capPrice: 0, numberOfInstallment: 1, intradayTrigger: 0, intradayLimit: 0, intradayTrailing: 0, intradayProfit: 0, discQty: 0, protPercent: 0, startDate: currentDate, gtdDate: dayjs(currentDate, 'YYYY-MM-DD'), targetSelPrice: 0, targetSelTriggerPrice: 0// Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other)
        });
        dispatch(placeSingleScripOrderFailure({})); // Important
        dispatch(placeSipOrderFailure({})); // Important
        dispatch(updateSingleScripOrderConfirmed(false));
        // Important and needed to send user back to SINGLE_SCRIP in sidetray and prevent a crash when clicking place a new order btn in multileg
        if (activeTabKey === ORDER_TYPES.MULTI_SCRIP && multiScripOrderActiveTabKey === ORDER_TYPES.MULTI_LEG) {
            setActiveTabKey(ORDER_TYPES.SINGLE_SCRIP);
            setMultiScripOrderActiveTabKey();
            dispatch(getMultiLegData(multiLegData));
        }
    };

    const handlePlaceOrderMultiScrip = () => {
        //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start
        if (multiScripOrderActiveTabKey === ORDER_TYPES.BASKET) {
            //BREEZE : 305 : Side tray Order Cart : ManasaB : 20-12-2024 : Taken product types from backend and Sl price sat issue - Start
            let arrPayloadOrders = [];
            arrOrderCartScripsInfo.forEach((eachOrder) => {
                let scripPrice = eachOrder.orderType === 'SL' && eachOrder.slLimit;
                let objOrderData = {
                    quantity: eachOrder.count,
                    transaction_type: eachOrder.buySellType,
                    product_type: eachOrder.productType.includes(ORDER_PRODUCT_TYPES.DELIVERY) ? ORDER_PRODUCT_TYPES.DELIVERY : eachOrder.productType.includes(ORDER_PRODUCT_TYPES.MARGIN) && ORDER_PRODUCT_TYPES.INTRADAY,
                    order_type: eachOrder.orderType,
                    // disclosed_quantity: eachOrder.disc,
                    is_amo: eachOrder.amo,
                    order_identifier: arrSaveCartResp[0].ordercartId,  //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues
                    price: eachOrder.orderType === 'SL' ? scripPrice : eachOrder.price, //BREEZE : 305 : Side tray Order Cart : ManasaB : 20-12-2024 : Taken product types from backend and Sl price sat issue - End
                    scrip_info: {
                        exchange: eachOrder.exchangeSegment,
                        expiry_date: "NA",
                        option_type: "NA",
                        scrip_token: eachOrder.token,
                        series: eachOrder.series,
                        strike_price: "NA",
                        symbol: eachOrder.symbol

                    },
                    trigger_price: eachOrder.slTrigger,
                    validity: eachOrder.validity,
                    validity_days: 0,
                    displayProductType: eachOrder.productType
                };
                arrPayloadOrders.push(objOrderData);

            });
            const objBasketPayload = {
                ordercartName: orderCartName,
                ordercartId: arrSaveCartResp[0].ordercartId,
                orders: arrPayloadOrders

            };
            dispatch(createOrderCartInfo(objBasketPayload))?.then((resp) => {
                dispatch(getOrderCartOrderSuccess(resp));
                setBIsConfirmBack(false);
                dispatch(getOrderDataBackupVertical([]));
            });

        }
        else {
            // Part of confirmation function to handle mulitleg order placement in vertical view
            if (multiScripOrderActiveTabKey === ORDER_TYPES.MULTI_LEG) {
                const exchangeNameById = getApiExchangeNameFromMktSegId(scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]);

                let multiLegInfo =
                {
                    "type": `${multiLegData?.length}L`,
                    "validity": ORDER_VALIDITY.IOC,
                    // Adds condition to check if even 1 leg is RL-MKT then order is RL-MKT else order is RL if both legs are RL
                    "order_type": multiLegData.some(legs => legs.orderType === ORDER_ENTRY_TYPES.RL_MKT) ? ORDER_ENTRY_TYPES.RL_MKT : ORDER_ENTRY_TYPES.RL, //ORDER_ENTRY_TYPES.RL_MKT,
                    "prot_perc": "",
                    "leg_details": []
                };
                multiLegInfo.leg_details = multiLegData?.map((element, i) => {
                    return {
                        leg_no: i + 1,
                        transaction_type: element?.activeButtonToggleIndex === 0 ? "BUY" : "SELL",
                        scrip_info: {
                            exchange: exchangeNameById,
                            scrip_token: element?.token,
                            symbol: element?.symbol?.trim(),
                            series: "XX",
                            expiry_date: moment(element?.expiryDate).format("DDMMMYYYY").toUpperCase(),
                            strike_price: element?.strikeprice === 'NA' ? "" : element?.strikeprice,
                            option_type: element?.optiontype === "NA" ? "" : element?.optiontype,
                            instrument_name: element?.instrument?.trim(),
                        },
                        //Parshva S : 5/4/24 : BT 102679 Mltileg Order // Ajitesh 26-07-2024 Adds OPTSTK to condition to pass quantity size instead of lot for options orders (NSEFAO)
                        quantity: scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_DERIVATIVES ? element?.count * element?.ask_qty : element?.count || 1, //Azeem K : 19-09-2024:added MARKET_SEGMENT_ID conditon instead of  SCRIP_INSTRUMENTS
                        price: element?.legPrice,
                        others: {
                            market_lot: element?.ask_qty,
                            price_tick: element?.priceTick, // AJitesh 30-07-2024 Adds price tick of element in case multileg has different scrips in case of commodity and currency
                            decimal_loc: element?.decLoc || scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                        },
                    };
                });
                dispatch(placeMultilegOrderAction(multiLegInfo))?.then((resp) => {
                    if (resp?.status === NETWORK_RESPONSE_STATUS.SUCCESS) {
                        const orderId = resp?.data?.data?.orderId;
                        objOrderStatusScripData = multiLegInfo;
                        dispatch(setShowSideOrderConfirmation(false));
                        dispatch(setShowSideTrayOrderstatus(true));
                    } else { }
                });
            }
        }
        //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End
    };

    const handleClose = () => {
        dispatch(placeSingleScripOrderFailure({})); // Important
        dispatch(placeSipOrderFailure({})); // Important
        //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
        dispatch(toastConfig({ show: false }));
        //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
        dispatch(setShowSideOrderConfirmation(false));
        dispatch(setShowSideTrayOrderstatus(false));
        dispatch(setShowSideTrayPlaceOrder(true));
        dispatch(getSpreadOrderSuccess({}));
        setToggleBracketOrder(curr => ({ ...curr, isShow: false }));
        setOrderInputs({ scripQuantity: 1, scripLot: 1, scripAmount: 0, slTrigger: 0, quantity: 0, capPrice: 0, numberOfInstallment: 0, intradayTrigger: 0, intradayLimit: 0, intradayTrailing: 0, intradayProfit: 0, discQty: 0, protPercent: 0, startDate: currentDate, gtdDate: defaultGtdDate });
        setActiveTabKey(ORDER_TYPES.SINGLE_SCRIP);
        setSelectOrderOption(objSelectOrderOptionInit);
        dispatch(getMarketStatusFailure([]));
        dispatch(orderMarginInfoFailure(null));
        dispatch(updateSingleScripOrderConfirmed(false));
        //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues - Start
        dispatch(getOrderCartOrderSuccess({}));
        dispatch(getOrderDataBackupVertical([]));
        dispatch(handleModalData({}));
        dispatch(getMultiLegData([])); // Ajitesh Empty multi leg data on side menu close
        dispatch(getMultiScriptSecongLegSuccess({})); // Adds correct redux action to prevent unnecessary api call and empties state correctly on sidetray menu close
        dispatch(getplaceMultilegOrderFailure([])); // Important
        dispatch(updateSpreadOrderInfo({}));
        //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues - End
    };

    const navigate = useNavigate();
    const routeChange = () => {
        dispatch(getMessagesOrders({ pageNo: 1 })); /* Deepti B. 110050: get recently placed order message */
        if (activeTabKey === ORDER_TYPES.SINGLE_SCRIP) {
            var path = "/orders?section=single_scrip";
            if (selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT) {
                path = "/orders?section=" + ORDER_TYPES.GOOD_TILL_DATE;
            } else { }
        } else if (activeTabKey === ORDER_TYPES.EQUITY_SIP) {
            path = "/orders?section=sip";
            sessionStorage.setItem(SESSION_STORAGE_KEYS.SEARCH_PARAMS, 'true');
        } else if (activeTabKey === ORDER_TYPES?.MULTI_SCRIP) {
            if (activeTabKey === ORDER_TYPES?.MULTI_SCRIP && multiScripOrderActiveTabKey === ORDER_TYPES?.SPREAD) {
                path = "/orders?section=spread";
            } else if (activeTabKey === ORDER_TYPES?.MULTI_SCRIP && multiScripOrderActiveTabKey === ORDER_TYPES?.MULTI_LEG) {
                path = "/orders?section=multi_leg";
                sessionStorage.setItem(SESSION_STORAGE_KEYS.SEARCH_PARAMS, 'true');
            }
            else if (activeTabKey === ORDER_TYPES?.MULTI_SCRIP && multiScripOrderActiveTabKey === ORDER_TYPES?.BASKET) {
                path = "/orders?section=basket";
            }
        }
        else { }
        handleClose();
        navigate(path);



    };


    //Ameersha N : 25-08-2023 : BT-107070 - Breeze - Spread Order entry - Start
    const handleSidePlaceOrderOfSpreadOrder = useCallback(() => {
        dispatch(placeMultilegOrderAction(multiSpreadOrderInfo?.spreadOrderPayload))?.then((resp) => {
            if (resp?.status === NETWORK_RESPONSE_STATUS?.SUCCESS) {
                dispatch(setShowSideOrderConfirmation(false));
                dispatch(setShowSideTrayOrderstatus(true));
            } else { }
        });
    }, [dispatch, multiSpreadOrderInfo]);
    //Ameersha N : 25-08-2023 : BT-107070 - Breeze - Spread Order entry - End

    const handleConfirmBtnOnClick = (e) => {
        e?.preventDefault();
        switch (activeTabKey) {
            case ORDER_TYPES.SINGLE_SCRIP: {
                handleOnConfirmSingleScripOrder();
                break;
            }
            case ORDER_TYPES.EQUITY_SIP: {
                handleOnCofirmSipOrder();
                break;
            }
            case ORDER_TYPES?.MULTI_SCRIP: {
                if (activeTabKey === ORDER_TYPES?.MULTI_SCRIP && multiScripOrderActiveTabKey === ORDER_TYPES?.SPREAD) {  //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024
                    handleSidePlaceOrderOfSpreadOrder();
                    break;
                } else {
                    handlePlaceOrderMultiScrip();
                    break;
                }
            }
            default:
                break;
        }
    };

    const handleConfirmBack = useCallback(() => {
        //Maaz A : 23-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FnO Bug Fixes - Start
        dispatch(placeSingleScripOrderSuccess({}));
        // dispatch(handleSpreadSideOrder(false));
        setSelectOrderOption(curr => ({ ...curr, isDefaultProductType: false }));
        //Maaz A : 23-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FnO Bug Fixes - End
        dispatch(setShowSideTrayPlaceOrder(true));
        if (activeTabKey === ORDER_TYPES.MULTI_SCRIP && multiScripOrderActiveTabKey === ORDER_TYPES.BASKET) {
            setBIsConfirmBack(true);
        }
        dispatch(setShowSideOrderConfirmation(false));
        dispatch(updateSingleScripOrderConfirmed(false));//Azeem K : 12-07-2024 : BT-102298 - Breeze - Single Scrip SideTray Order entry
        dispatch(getplaceMultilegOrderFailure([])); // Important
    }, [multiSpreadOrderInfo, multiScripOrderActiveTabKey]);
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
    //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues  - Start
    const handleSaveCartBack = () => {
        setBIsShowCreateCart(false);
        dispatch(setShowSideTrayPlaceOrder(true));
        setBIsSaveCartBack(true);
    };
    //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues - End
    // Maaz A - For Pre Setting Order Entry Values - Start
    //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
    useImperativeHandle(ref, () => ({
        orderInputs,
        setOrderInputs,
        selectOrderOption,
        setSelectOrderOption,
        setToggleBracketOrder,
        isScripPrice,
        setIsScripPrice
    }));
    //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
    // Maaz A - For Pre Setting Order Entry Values - End

    //Maaz A : 10-10-2023 : BT-102298 - Breeze - Single Scrip Order entry : GTD Order - Start
    const nGTDNoOfDays = useMemo(() => {
        if (orderInputs?.gtdDate) {
            const strGTDSelDate = orderInputs?.gtdDate.format('DD-MM-YYYY');
            let gtdSelDate = moment(strGTDSelDate, 'DD-MM-YYYY');
            let currDate = moment(moment().format('DD-MM-YYYY'), 'DD-MM-YYYY');
            const nGTDNoOfDays = gtdSelDate.diff(currDate, 'days');
            return nGTDNoOfDays;
        } else {
            return 0;
        }
    }, [orderInputs?.gtdDate]);
    //Maaz A : 10-10-2023 : BT-102298 - Breeze - Single Scrip Order entry : GTD Order - End
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 -Start
    const onHandleChange = (e) => {
        setOrderCartName((e.target.value).toUpperCase()); //BT-106965 : ManasaB : 27/03/2024 : Order Cart : SAT1 issues

    };
    const handleKeyDown = (event) => {
        if (!/^[a-zA-Z0-9]*$/.test(event.key)) {
            event.preventDefault();
        }
    };
    const checkCartNameExists = () => {
        const objExistCartData = arrCartNames.find(eachCartName => eachCartName.ordercartName === orderCartName);
        //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues  - Start
        if (objExistCartData) {
            return { cartData: objExistCartData, isExist: true };
        }
        else {
            return { isExist: false };
        }
        //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues  - End
    };
    const handleSaveCart = () => {
        let nPriceSL = '';
        let arrOrders = arrOrderCartScripsInfo?.map(eachData => {
            // let arrOrders = arrCartOrderData?.map(eachData => {
            //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To send sl limit values when order type is SL - Start
            if (eachData.orderType === 'SL') {
                nPriceSL = eachData.slLimit;
            }
            //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To send sl limit values when order type is SL - End
            let objOrder = {
                LTP: eachData.price,
                PercNetChange: 0.00,
                OpenPrice: 0.00,
                HighPrice: 0.00,
                LowPrice: 0.00,
                ClosePrice: 0.00,
                NetChangeInRs: 0.00,
                LUT: "",
                LTPTrend: "",
                arrowTrend: "",
                PercNetChangeRaw: "",
                BuyPrice: 0.00,
                BuyQty: 0.00,
                SellPrice: 0.00,
                SellQty: 0.00,
                Volume: 0.00,
                LTPChangeCss: "",
                scripDetail:
                {
                    symbol: eachData.symbol,
                    _Series: eachData.series,
                    _InstrumentName: eachData.instrument,
                    _ExchangeName: eachData.exchange,
                    _ExpiryDate: "NA",
                    _OptionType: "NA",
                    _StrikePrice: "NA",
                    MarketLot: eachData.marketLot, // BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024
                    PriceTick: eachData.priceTick, // BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024
                    SecurityDesc: eachData.securityDesc,
                    MWSecurityDesc: `${eachData.symbol}    ${eachData.series}`,
                    DecimalLocator: eachData.decimalLocator,
                    PriceFormat: "",
                    ISIN: eachData.isinCode,
                    SPOS: "",
                    POS: "",
                    OrderType: "",
                    Quantity: 0,
                    Price: 0,
                    ProductType: "",
                    AssetToken: 0,
                    Spread: 0,
                    FIILimit: 0,
                    NRILimit: 949,
                    FOExists: 1,
                    MarginTypeIndicator: 1,
                    priceNumerator: 1,
                    priceDenominator: 1,
                    genNumerator: 1,
                    genDenominator: 1,
                    intrinsicValue: 1,
                    displaySymbol: eachData.symbol,
                    displaySeries: eachData.series,
                    displayExchange: eachData.exchange,
                    displayInstrument: eachData.instrument,
                    displayExpiryDate: "",
                    displayStrikePrice: "",
                    displayOptionType: "",
                    exchangeColorCss: "nse",
                    isIndex: false,
                    spotIndex: 0,
                    BidAskPrice: 0.00,
                    BidAskQuantity: 0,
                    BestFive: [],
                    LTP: eachData.price,
                    NetChangeInRs: 0.00,
                    PercNetChange: 0.00,
                    LTPTrend: "",
                    totalBuyQty: 0,
                    totalSellQty: 0,
                    totalBidQtyPer: "-",
                    totalAskQtyPer: "-",
                    maturityDate: 0,
                    expiryInMilliSec: 0,
                    sQtyUnit: "",
                    sSurvMeasureDescription: null,
                    nSequenceNo: "",
                    scripDet:
                    {
                        isIndex: false,
                        sIndexDesc: "",
                        isGlobal: 0,
                        token: eachData.token,
                        _MktSegId: eachData.mappedSegId,
                        _MapMktSegId: eachData.mappedSegId // need to do
                    }
                },
                requestBody: {
                    quantity: eachData.count,
                    transaction_type: eachData.buySellType,
                    product_type: eachData.productType,
                    order_type: eachData.orderType,
                    disclosed_quantity: eachData.disc,
                    is_amo: eachData.amo,
                    price: nPriceSL ? nPriceSL : eachData.price,
                    order_identifier: "",
                    scrip_info: {
                        exchange: eachData.exchangeSegment,
                        expiry_date: "NA",
                        option_type: "NA",
                        scrip_token: eachData.token,
                        series: eachData.series,
                        strike_price: "NA",
                        symbol: eachData.symbol
                    },
                    trigger_price: eachData.slTrigger,
                    validity: eachData.validity,
                    validity_days: 0,
                    displayProductType: eachData.productType
                },
                selected: false,
                BGChangeCSS: "nochange-bg"
            };
            return objOrder;
        });
        //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues - Start
        const objCheckCartExists = checkCartNameExists();
        const bCheckCartExists = objCheckCartExists.isExist;
        let objPayload = {};
        if (!bIsConfirmBack) {
            objPayload = {
                ordercartName: orderCartName,
                version: 1,
                createdBy: objLoginSession.data.user_id,
                modifiedBy: objLoginSession.data.user_id,
                executedNoTime: 0,
                orders: JSON.stringify(arrOrders)
            };
        }
        else {

            objPayload = {
                ordercartId: objCheckCartExists.cartData?.ordercartId,
                ordercartName: orderCartName,
                version: 1,
                createdBy: objLoginSession.data.user_id,
                modifiedBy: objLoginSession.data.user_id,
                executedNoTime: 0,
                orders: JSON.stringify(arrOrders)
            };
        }
        if (!bCheckCartExists) {
            dispatch(saveCartInfo(objPayload)).then((resp) => {
                if (resp?.status === 'success') {
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: `${orderCartName} saved successfully` }));
                    setArrSaveCartResp(resp.data);
                    dispatch(getOrderCartAction());
                    dispatch(setShowSideOrderConfirmation(true));
                    setBIsShowCreateCart(false);
                    // dispatch(saveCartSuccess(true));
                }
            });
        }
        else if (bCheckCartExists && bIsConfirmBack) {
            dispatch(updateOrderCartAction(objPayload, `${orderCartName} updated successfully`)).then((resp) => {
                if (resp?.status === 'success') {
                    dispatch(getOrderCartAction()); //Manasa : 19/03/2024 : Order cart flow changes after discussion with Samadhan
                    // setArrSaveCartResp(resp.data);
                    dispatch(setShowSideOrderConfirmation(true));
                    setBIsShowCreateCart(false);
                }
                dispatch(toastConfig({ autoDismiss: true, show: true, message: `${orderCartName} updated successfully` }));
            });
        }
        else {
            dispatch(toastConfig({ autoDismiss: false, show: true, message: 'Looks like this cart name already exists. Try using a different name.', button: [{ btnName: "Close", type: "Close_Toast_MultiScrip_OrderCart", className: "btn btn-outline-active ms-3", bIsDisabled: false }] }));
        }
        //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues - End
    };
    useEffect(() => {
        if (Object.keys(objModalData).length > 0) {
            if (objModalData?.data?.isSurvMeasureAccepted) {
                dispatch(setShowSideTrayPlaceOrder(false));
                // dispatch(handleModalData({}));
                orderEntryMultiScripRef?.current?.saveCartData();
            }
        }
    }, [objModalData, dispatch]);
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End

    useEffect(() => {
        setBIsSiderTrayOrderEntryOpen(true);
        return (() => {
            setBIsSiderTrayOrderEntryOpen(false);
            dispatch(setShowSideTrayPlaceOrder(true));
            dispatch(setShowSideOrderConfirmation(false));
            dispatch(setShowSideTrayOrderstatus(false));
            handleClose();
            dispatch(updateMultiLegOrderConfirmed(false));
        });
    }, []);

    const handleClickOnClose = () => {
        setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; });
        setToggleSideContainer(false);
        setActiveMenu({}); //BT- 112339:Watchlist||Side Tray | Closing functionality: ManasaB: 30/06/23
        handleClose();
    };


    const onMarketChange = (selectedExchangeScrip) => {
        setIsScripPrice(false);
        setToggleBracketOrder(curr => ({ ...curr, isShow: false, strProductType: ORDER_PRODUCT_TYPES.COVER }));
        dispatch(getScripOrderInfo({ isBuySell: activeButtonToggleIndex, activeExchangeId: selectedExchangeScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: selectedExchangeScrip }));
    };
    return (
        <>
            {exchangeAllowed ?
                <>
                    <form onSubmit={bIsShowSideTrayPlaceOrder ? handlePlaceSideOrder : bIsShowSideTrayOrderConfirmation ? handleConfirmBtnOnClick : null}>
                        <ContainerHeader>
                            {
                                bIsShowSideTrayPlaceOrder &&
                                <>
                                    <Container fluid className='p-0'>
                                        <Row className='g-0 bdr-btm p-3 pb-0 stickysidemenu-top-header'>
                                            <Col md={10} className='d-flex justify-content-start align-self-center'>
                                                <PlaceOrderTabs scripOrderInfo={scripOrderInfo} arrPlaceOrderInfo={arrPlaceOrderInfo} activeTabKey={activeTabKey} setActiveTabKey={setActiveTabKey} setMultiScripOrderActiveTabKey={setMultiScripOrderActiveTabKey} />
                                            </Col>
                                            <Col md={2} className='d-flex justify-content-end align-self-center'>
                                                <div className='icon-16 icon-dark icon-close'
                                                    onClick={handleClickOnClose}>
                                                </div>
                                            </Col>
                                        </Row>
                                        {
                                            (activeTabKey === ORDER_TYPES.SINGLE_SCRIP || activeTabKey === ORDER_TYPES.EQUITY_SIP) &&
                                            <>
                                                <Row className='g-0 mt-2 mb-3'>
                                                    <Col md={8} className='d-flex justify-content-start align-items-start'>
                                                        <PlaceOrder arrPlaceOrderInfo={arrPlaceOrderInfo} activeTabKey={activeTabKey} isHeader={true} />
                                                    </Col>
                                                    <Col md={4} className={`d-flex justify-content-end ${activeTabKey === ORDER_TYPES.EQUITY_SIP ? 'align-items-center' : 'align-items-start'} pe-3`}>
                                                        {activeTabKey === ORDER_TYPES.EQUITY_SIP ?
                                                            <div className='buy-wrap-sip'><div className='btn btn-sm btn-positive'>Buy</div></div>
                                                            : <BzToggleButton type='button'
                                                                wrapperClassName={`buysell-wrap ${activeTabKey === ORDER_TYPES.EQUITY_SIP && (scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES] !== 'EQ' || !bIsSipAllowed) ? 'd-none' : ''}`}
                                                                leftButtonClassName={`btn btn-sm ${activeButtonToggleIndex === 0 ? 'btn-positive' : ''}`}
                                                                rightButtonClassName={`btn btn-sm ${activeButtonToggleIndex === 1 ? 'btn-negative' : ''}`}
                                                                leftButtonTitle="BUY" rightButtonTitle="SELL" activeButtonToggleIndex={activeButtonToggleIndex} setActiveButtonToggleIndex={updateActiveButtonToggleIndex}
                                                                isDisabled={activeTabKey === ORDER_TYPES.EQUITY_SIP} />
                                                        }
                                                    </Col>
                                                </Row>
                                                {
                                                    activeTabKey === ORDER_TYPES.EQUITY_SIP && bIsSipAllowed && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES] != '' ?
                                                        <Row className='g-0 mb-3 px-3'>
                                                            <Col className='d-flex align-items-center horizontal-scroll-wrap pb-1'>
                                                                <div className='exch-radiochip-wrap'>
                                                                    {arrDistinctScripExchanges?.length > 0 && arrDistinctScripExchanges?.map((each, i) => {
                                                                        return (
                                                                            <BzChip key={i} onClick={(e) => onMarketChange(each)} className={`me-2 radio-chip ${scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == each[WATCHLIST_GRID_INDEX.SEGMENT_ID]}'active'`}>
                                                                                <div data-testid={`exchangeAllowed`} className={`exch-namechip ${scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == each[WATCHLIST_GRID_INDEX.SEGMENT_ID] ? 'active' : ''}`}>{each[WATCHLIST_GRID_INDEX.EXCHANGE]}</div>
                                                                                <div className='font-regular font-size1 color-primary text-end'>{activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY ? each[WATCHLIST_GRID_INDEX.ASK_PRICE] : each[WATCHLIST_GRID_INDEX.BID_PRICE]}</div>
                                                                                <div className='font-regular font-size1 color-subtext text-end'>QTY: {activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY ? each[WATCHLIST_GRID_INDEX.ASK_QTY] : each[WATCHLIST_GRID_INDEX.BID_QUANTITY]}</div>
                                                                            </BzChip>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        : null
                                                }
                                                {
                                                    activeTabKey === ORDER_TYPES.SINGLE_SCRIP &&
                                                    <Row className='g-0 mb-3 px-3'>
                                                        <Col className='d-flex align-items-center horizontal-scroll-wrap pb-1'>
                                                            <div className='exch-radiochip-wrap'>
                                                                {arrDistinctScripExchanges?.length > 0 && arrDistinctScripExchanges?.map((each, i) => {
                                                                    return (
                                                                        <BzChip key={i} onClick={(e) => onMarketChange(each)} className={`me-2 radio-chip ${scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == each[WATCHLIST_GRID_INDEX.SEGMENT_ID]}'active'`}>
                                                                            <div data-testid={`exchangeAllowed`} className={`exch-namechip ${scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == each[WATCHLIST_GRID_INDEX.SEGMENT_ID] ? 'active' : ''}`}>{each[WATCHLIST_GRID_INDEX.EXCHANGE]}</div>
                                                                            <div className='font-regular font-size1 color-primary text-end'>{activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY ? each[WATCHLIST_GRID_INDEX.ASK_PRICE] : each[WATCHLIST_GRID_INDEX.BID_PRICE]}</div>
                                                                            <div className='font-regular font-size1 color-subtext text-end'>QTY: {activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY ? each[WATCHLIST_GRID_INDEX.ASK_QTY] : each[WATCHLIST_GRID_INDEX.BID_QUANTITY]}</div>
                                                                        </BzChip>
                                                                    );
                                                                })}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                }
                                            </>
                                        }
                                        {
                                            (objCFT.MULTILEG === FACILITY_NUM.ON || objCFT.BULKORDER === FACILITY_NUM.ON) && activeTabKey === ORDER_TYPES.MULTI_SCRIP &&
                                            <Row className='g-0 mt-2 mb-4 px-3'>
                                                <Col>
                                                    <div className='submenu-wrapper d-flex align-items-center'>
                                                        {
                                                            objCFT.BULKORDER === FACILITY_NUM.ON &&
                                                            <div onClick={() => { setMultiScripOrderActiveTabKey(ORDER_TYPES.BASKET); }} className={`submenuItem ${multiScripOrderActiveTabKey === ORDER_TYPES.BASKET ? 'active' : ''}`}>Order Cart</div>
                                                        }
                                                        {
                                                            objCFT.MULTILEG === FACILITY_NUM.ON &&
                                                            <>
                                                                <div onClick={() => { setMultiScripOrderActiveTabKey(ORDER_TYPES.SPREAD); }} className={`submenuItem ${multiScripOrderActiveTabKey === ORDER_TYPES.SPREAD ? 'active' : ''}`}>Spread</div>
                                                                <div onClick={() => { setMultiScripOrderActiveTabKey(ORDER_TYPES.MULTI_LEG); }} className={`submenuItem ${multiScripOrderActiveTabKey === ORDER_TYPES.MULTI_LEG ? 'active' : ''}`}>MultiLeg</div>
                                                            </>
                                                        }
                                                    </div>
                                                </Col>
                                            </Row>
                                        }
                                    </Container>
                                </>
                            }
                            {/* BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start */}
                            {
                                bIsShowCreateCart &&
                                <Container fluid className='p-0'>
                                    <Row className='g-0 bdr-btm p-3'>
                                        <Col md={10} className='d-flex justify-content-start align-items-center'>
                                            <div className='icon-12 icon-backward-arrow icon-primary me-2' onClick={handleSaveCartBack}></div>
                                            <div className='font-medium font-size5 color-text  mt-1'>Name your Order Cart</div>
                                        </Col>
                                    </Row>
                                </Container>
                            }
                            {/* BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End */}
                            {
                                bIsShowSideTrayOrderConfirmation &&
                                <Container fluid className='p-0'>
                                    <Row className='g-0 bdr-btm p-3'>
                                        <Col md={10} className='d-flex justify-content-start align-items-center'>
                                            <div className='icon-12 icon-backward-arrow icon-primary me-2' onClick={handleConfirmBack}></div>
                                            <div className='font-medium font-size5 color-text  mt-1'>Confirm your
                                                {!(activeTabKey === ORDER_TYPES.MULTI_SCRIP && multiScripOrderActiveTabKey === ORDER_TYPES.BASKET) &&
                                                    <>
                                                        {
                                                            multiScripOrderActiveTabKey === ORDER_TYPES.SPREAD ? <span className='px-1'>Spread</span> : multiScripOrderActiveTabKey === ORDER_TYPES.MULTI_LEG ? <span className='px-1'>Multileg</span> : activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY ?
                                                                <span className='px-1 color-positive'>Buy</span> :
                                                                <span className='px-1 color-negative'>Sell</span>
                                                        }</>}
                                                <span className='ps-1'>Order</span>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            }
                            {bIsShowSideTrayOrderStatus &&
                                <Container fluid className='p-0'>
                                    <Row className='g-0 stickysidemenu-top-header bdr-btm py-2 px-3'>
                                        <Col className='d-flex justify-content-end align-self-center'>
                                            <div className='icon-16 icon-dark icon-close' onClick={handleClickOnClose}></div>
                                        </Col>
                                    </Row>
                                </Container>
                            }

                        </ContainerHeader>
                        {/* BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start */}
                        <ContainerBody>
                            {bIsShowSideTrayPlaceOrder ?
                                <PlaceOrder arrPlaceOrderInfo={arrPlaceOrderInfo} activeTabKey={activeTabKey} isHeader={false} /> : (
                                    bIsShowSideTrayOrderConfirmation ?
                                        <SideOrderConfirmation GTDNoOfDays={nGTDNoOfDays} defaultGtdDate={defaultGtdDate} orderEntryTab={activeTabKey} handleClose={handleClose} activeTabKey={multiScripOrderActiveTabKey} setIsChecked={setIsChecked} scripOrderInfo={scripOrderInfo} isChecked={isChecked} selectOrderOption={selectOrderOption} orderInputs={orderInputs} activeButtonToggleIndex={activeButtonToggleIndex} marginInfoHandler={marginInfoHandler} bIsConfirmBtn={bIsConfirmBtn} setBIsConfirmBtn={setBIsConfirmBtn} layoutType={LAYOUT_TYPE.VERTICAL} arrMultiLegInfo={multiLegData} bIsCoverBracketOrderOpen={toggleBracketOrder?.isShow} />
                                        : (bIsShowCreateCart ? (<>
                                            <Container fluid className='p-0 p-3'>
                                                <Row className='g-0 mb-3'>
                                                    <Col md={10}>
                                                        <div className='font-regular font-size4 color-text'>Order cart will be saved inside the hamburger menu (<span className='icon-12 icon-dark icon-hamburger'></span>)</div>
                                                    </Col>
                                                </Row>
                                                {bIsConfirmBack ?
                                                    <div className='font-regular font-size2 color-text'>Update Order Cart </div> : <div className='font-regular font-size3 color-text'>Save Order Cart as: </div>}
                                                <Row className='g-0 mb-3'>
                                                    <Col className='d-flex justify-content-start'>
                                                        <div className='input-group'>
                                                            <BzInputText size='sm' className='font-regular form-control' placeholder='Enter new name here' name="ordercart" maxLength={10} minLength={1} value={orderCartName} onChange={onHandleChange} onKeyDown={handleKeyDown} />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </>) :
                                            (
                                                bIsShowSideTrayOrderStatus && <OrderStatusBody orderInputs={orderInputs} defaultGtdDate={defaultGtdDate} objScripData={objOrderStatusScripData} scripOrderInfo={scripOrderInfo} orderEntryTab={activeTabKey} orderId={objSingleScripOrderResp?.data?.orderId} activeTabKey={multiScripOrderActiveTabKey} />
                                            ))
                                )
                            }
                            {/* BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 -End */}
                        </ContainerBody>

                        <ContainerFooter>
                            <Container fluid className='p-0 bdr-top px-3'>
                                {
                                    (!bIsShowSideTrayOrderStatus && activeTabKey !== ORDER_TYPES.EQUITY_SIP && (activeTabKey === ORDER_TYPES.MULTI_SCRIP && multiScripOrderActiveTabKey !== ORDER_TYPES.MULTI_LEG && multiScripOrderActiveTabKey !== ORDER_TYPES.SPREAD)) &&  // Modified condition to NOT show brokerage and margin when opening multi leg in sidetray
                                    <>
                                        <Row className='g-0 py-3'>
                                            <Col md={8}>
                                                <Row className='g-0'>
                                                    <Col className='d-flex justify-content-start align-self-center'>
                                                        <div className='font-regular font-size1 color-text'>Approx. Margin:</div>
                                                        <div className='font-medium font-size1 color-text ms-1'>
                                                            {isLoadingMarginInfo ? <BzDotsLoader /> : (!isNaN(parseFloat(arrMarginInfo?.ApproxMargin)) ? convertNumberWithCommasForCurrency(parseFloat(arrMarginInfo?.ApproxMargin), true) : arrMarginInfo?.arrMarginInfo?.ApproxMargin)}
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className='g-0'>
                                                    <Col className='d-flex justify-content-start align-self-center'>
                                                        <div className='font-regular font-size1 color-text'>Available Margin:</div>
                                                        <div className='font-medium font-size1 color-text ms-1'>
                                                            {isLoadingMarginInfo ? <BzDotsLoader /> : (!isNaN(parseFloat(arrMarginInfo?.AvailableMargin)) ? convertNumberWithCommasForCurrency(parseFloat(arrMarginInfo?.AvailableMargin), true) : arrMarginInfo?.AvailableMargin)}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            {!isLoadingMarginInfo &&
                                                <Col md={4} className='d-flex justify-content-end align-items-start'>
                                                    <div className='d-flex cursor-pointer focus p-1' onClick={marginInfoHandler}>
                                                        <div className='icon-16 icon-refresh background-textual-link-withicon'></div>
                                                        <div className='font-medium font-size2 color-textual-link-withicon ms-2'>Update</div>
                                                    </div>
                                                </Col>
                                            }
                                        </Row>
                                    </>
                                }
                                {bIsShowSideTrayPlaceOrder && <>
                                    <Row className='g-0 py-2'>
                                        <Col className='d-grid'>
                                            <BzButton type='submit' disabled={bIsPlaceOrderBtnDisabled || (!bIsSipAllowed && activeTabKey === ORDER_TYPES.EQUITY_SIP)} className={`btn btn-md text-capitalize ${activeTabKey === ORDER_TYPES.MULTI_SCRIP ? "btn-primary" : activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY ? 'btn-positive' : 'btn-negative'}`} onClick={handlePlaceSideOrder}>
                                                {activeTabKey === ORDER_TYPES.MULTI_SCRIP && multiScripOrderActiveTabKey === ORDER_TYPES.BASKET ? 'SAVE CART & PLACE ORDER' : 'Place Order'} {/* BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024  */}
                                            </BzButton>
                                        </Col>
                                    </Row>
                                </>
                                }

                                {bIsShowSideTrayPlaceOrder && activeTabKey !== ORDER_TYPES.EQUITY_SIP && activeTabKey !== ORDER_TYPES.MULTI_SCRIP &&
                                    <Row className='g-0 mb-2'>
                                        <Col className='text-center'>
                                            <a className='font-medium font-size2 focus p-1' disabled={isBrokerageDisabled} onClick={onViewBrokerageAndCharges}>View Brokerage and Charges</a>
                                        </Col>
                                    </Row>
                                }
                                {/* BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start */}
                                {
                                    bIsShowCreateCart &&
                                    <Row className='g-0 my-2'>
                                        <Col>
                                            {bIsConfirmBack ? <BzButton disabled={!bIsConfirmBtn} onClick={handleSaveCart} className='btn btn-block btn-primary text-uppercase mt-1'>
                                                Continue
                                            </BzButton> : <BzButton disabled={!bIsConfirmBtn || orderCartName?.length === 0} onClick={handleSaveCart} className='btn btn-block btn-primary text-uppercase mt-1'>
                                                Save & Continue
                                            </BzButton>}
                                        </Col>
                                    </Row>
                                }
                                {/* BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End */}
                                {
                                    bIsShowSideTrayOrderConfirmation &&
                                    <Row className='g-0 my-2'>
                                        <Col>
                                            <BzButton type='submit' autoFocus disabled={!bIsConfirmBtn} onClick={handleConfirmBtnOnClick} className='btn btn-block btn-primary'>
                                                Confirm
                                            </BzButton>
                                        </Col>
                                    </Row>
                                }
                                {
                                    bIsShowSideTrayOrderStatus &&
                                    <>
                                        <Row className='g-0 py-1 px-3'>
                                            <Col>
                                                <BzButton type='button' className='btn btn-block btn-primary' autoFocus onClick={routeChange}>Order Status</BzButton>
                                            </Col>

                                        </Row>
                                        <Row className='g-0 py-1 px-3'>
                                            <Col>
                                                <BzButton type='button' className='btn btn-block btn-outline' onClick={handlePlaceNewOrder}>Place a new order</BzButton>
                                            </Col>
                                        </Row>
                                    </>
                                }
                            </Container>
                        </ContainerFooter>
                    </form>
                    <BrokerageCharges brokerageParams={brokerageParams} activeButtonToggleIndex={activeButtonToggleIndex} />
                    {modals["LTP_PRICE_BAND_VALIDATION_ERROR_MODAL"] ? <LtpPriceBandValidationInfoModal legsThatFailLtpPriceValidation={legsThatFailLtpPriceValidation} />
                        : null
                    }
                </> :
                <Container className='p-0'>
                    <Row className='g-0 bdr-btm p-3'>
                        <Col md={10} className='d-flex justify-content-start align-self-center'>
                            <div className='font-medium font-size5 color-text text-uppercase'>PLACE ORDER</div>
                            {props.children}
                        </Col>
                        <Col md={2} className='d-flex justify-content-end align-self-center'>
                            <div className='icon-16 icon-dark icon-close'
                                onClick={handleClickOnClose}>
                            </div>
                        </Col>
                    </Row>
                    <div className='zero-state-alerts zero-state-alerts-lg'>
                        <ZeroStates subTextClass='font-medium font-size2 color-nodata' subText="You are currently not allowed to place/modify/cancel order in this segment" icon='icon-64 icon-nodata mb-3 mrgauto' />
                    </div>
                </Container>}
            {/* Vaibhav Singh: NSEEQ Order Entry: 31-01-24: Sidebar Not allowed for unavailable exchanges fixed: End */}
        </>



    );
});

export default memo(SidePlaceOrder);